/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useDebounce } from 'use-lodash-debounce';
import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { hasFeatureAccess } from 'src/utils/featurePermission';
import { EmptyContent } from 'src/components/empty-content';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import _, { isArray, isEmpty, isPlainObject } from 'lodash';
import { shallowEqual } from 'react-redux';
import useSnackbar from 'src/hooks/useCustomSnackbar';
// use @mui
import {
    Box,
    Card,
    Tab,
    Tabs,
    InputAdornment,
    TextField,
    Button,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Popper,
    Grow,
    Paper,
    ClickAwayListener,
    Typography,
    useTheme,
    useMediaQuery,
} from '@mui/material';
// sections
import SelectArchiveReasons from 'src/components/Dropdowns/SelectArchiveReasons';
import { updateLeadDataCount } from 'src/redux/slices/whatsapp';
import { updateSuperAdmin } from 'src/redux/slices/superAdmin';
import capitalizeFirstLetter from 'src/utils/capitalizedFunc';
import { updatePracticeIdToChange } from 'src/redux/slices/practiceTreatmentList';
import { loadCustomTabs, selectCustomTabsForParent } from 'src/redux/slices/customTableTabs';
import { PracticeEditDialog } from '../../sections/@dashboard/practiceTreatment';
import { AppointmentPage, FollowUp } from '../../sections/@dashboard/lead';
import { Activities } from '../../sections/@dashboard/leadDetail';
import {
    TreatmentAndAppointment,
    PaymentOption,
    PersonalDetails,
    MessageAndReminder,
} from '../../sections/@dashboard/general/app';
// component
import DashBoardReportsWidget from '../../components/reportsWidget/DashBoardReportsWidget';
import AttendedTableReportsWidget from '../../components/reportsWidget/AttendedTableReportsWidget';
import StartedTableReportsWidget from '../../components/reportsWidget/StartedTableReportsWidget';
import FTATableReportsWidget from '../../components/reportsWidget/FTATableReportsWidget';
import ClinCheckStatusPopup from '../../components/dialogPopUp/ClinCheckStatusPopup';
import BookedTableReportsWidget from '../../components/reportsWidget/BookedTableReportsWidget';
import NewLeadTableReportsWidget from '../../components/reportsWidget/NewLeadTableReportsWidget';
import { Iconify, Label, MultiDatePicker } from '../../components';
import FloatingBulkActionBar from '../../components/BulkActionBar/FloatingBulkActionBar';
import { ReferralDropdown, MultiTreatmentDropdown, PracticeDropdowns } from '../../components/Dropdowns';
import MultiAssigneesDropdown from '../../components/Dropdowns/SelectMultiAssignees';
import { AttendedAppointment } from '../../components/Attended';
import { SearchAutocompleteTags } from '../../components/AutoComplete';
import {
    ArchivedLeadPopUp,
    AssignTaskPopup,
    EditPersonalDetailsPopup,
    AppointmentAssignTaskPopup,
    ArchivedOrRestorePopup,
    AttendedNotePopup,
    BulkReminderPopup,
} from '../../components/dialogPopUp';
import SmartBulkReminderModal from '../../components/dialogPopUp/SmartBulkReminderModal';
import { UnableToContact } from '../../components/failedToAttendTabs';
import WhatsAppFollowUpStep from '../../components/WhatsAppFollowUpStep';
import WhatsAppCloseStep from '../../components/WhatsAppCloseStep';
import { TableFilterResult } from '../../components/table';
import {
    OpenDialogPopup,
    OpenConsultationPopup,
    OpenAttendedPopup,
    OpenUnAttendedPopup,
    OpenRestoreArchived,
    OpenEditAppointmentPopup,
    OpenContactLeadPopup,
    OpenAppointmentPopup
} from '../../components/fullScreenPopUps';
import { DentallyPaymentConfirmation, DentallyTreatmentAvailabilityWizardStep, DentallyFollowUpConfirmWizardStep, BookingModeToggle } from '../../components/dentally';
import { PmsAvailabilityWizardStep, PmsBookingConfirmStep } from '../../components/pms';
import { useDateRangePicker } from '../../components/date-range-picker';
import TreatmentPlanDatePicker from '../../components/dialogPopUp/TreatmentPlanDatePicker';
import { NewLeadDataGrid } from './tables/AllLeadTable/NewLeadDataGrid';
import { resolveTabLabel } from '../superAdmin/tableDefaults/constants';
import { selectGlobalPrefForTable } from '../../utils/globalTablePrefsCascade';
import { AlignerApproveLeadDataGrid } from './tables/AllLeadTable/AlignerApproveLeadDataGrid';
import TreatmentEditPopover from './tables/AllLeadTable/TreatmentEditPopover';
import { FormProvider } from '../../components/hook-form';
import DepositPaymentPopover from './tables/AllLeadTable/DepositPaymentPopover';
import StartTreatmentPopup from '../../components/dialogPopUp/StartTreatmentPopup';
import CustomConfirmationDialog from './tables/AllLeadTable/CustomConfirmationDialog';
import CustomCompleteTreatmentDialog from './tables/AllLeadTable/CustomCompleteTreatmentDialog';

// redux
import { completedToStart, markAsDuplicate, unMarkAsDuplicate } from '../../redux/slices/duplicateLeads';
import { markAsSpam } from '../../redux/slices/spamLeads';
import { setCurrentTreatmentDataGlobal } from '../../redux/slices/multiTreatment';
import { getActivities } from '../../redux/slices/activity';
import { dispatch, useSelector } from '../../redux/store';
import {
    selectLoadingForLead,
    selectIsAppointmentBooked,
    selectAttendance,
    selectFollowUpLead,
    selectFollowLead,
    selectMarkAsComplete,
    selectContactLead,
    selectBookingAttendance,
    selectMultiLead,
    selectTaskTableData,
    selectAction,
    selectTableRowLead,
} from '../../redux/selectors/leadSelectors';
import {
    clearLead,
    updateSteps,
    updateFollowUpLead,
    updateLeadDetail,
    ConsultationAttended,
    RecordAttended,
    recordUnAttended,
    getLeadReminderData,
    ArchivedLeadDashBoard,
    restoreArchived,
    CompleteTreatment,
    startLoadingData,
    updateCounter,
    StartingTreatment,
    updateDashNewLead,
    dashNewTableCounter,
    selectLeads,
    updateTableType,
    startArchivedLoading,
    startLoadingDepositPending,
    UpdateDepositPendingStatus,
    setAction,
    followUpSlice,
} from '../../redux/slices/lead';
import { clearPracticeUserData } from '../../redux/slices/practiceUser';
import { getPracticeItem } from '../../redux/slices/practice';
import { setCallScriptSection } from '../../redux/slices/callScript';
import { clearMessage, getPracticeTreatmentList } from '../../redux/slices/practiceTreatment';
import { setLoader } from '../../redux/slices/loader';
// hooks/constants/util
import {
    useTabs,
    useToggle,
    useConsultationAttendToggle,
    useRecordAttendToggle,
    useUnRecordAttendToggle,
    useArchivedToggle,
    useAddTreatment,
    useTable,
    useRestoreArchived,
    useAssignTaskToggle,
    useBoolean,
    useLeadTableHelper,
    useAppointmentToggle
} from '../../hooks';
import useTableQueryParams from '../../hooks/useTableQueryParams';
import {
    TAB_HEAD_FOLLOW_UP,
    TAB_HEAD_NO_TASK,
    DASH_NEW_HEADER,
    CONSULTANT_BOOKED_HEAD,
    CONSULTANT_ATTENDED_SINGLE_HEAD,
    buildAttendedCountFilterQuery,
    CONSULTANT_CLINCHECK_ATTENDED_HEAD,
    ATTENDED_CHECKLISTS_TAB_HEAD,
} from '../../constants/newLead';
import { CreateLeadHeaderData } from '../../constants/LeadDetailConst';
import {
    SelectTableTab,
    TabCount,
    TablePageNumber,
    TablePerPage,
    TableSearch,
    TableTreatment,
    TableFilterDate,
    TableStatus,
    TableFilterTags,
    TableOrder,
    TableOrderBy,
    TableReferral,
    TableCategory,
    TableCategoryName,
    TableBookedWith,
    TableTags,
    UpdateTableData,
    TableDepositPending,
    TableConsultationBookedWith,
    TableAssignees,
    TableArchiveReason,
    TablePracticeFilter,
    TableContactedCountFilter,
    TableChecklistState,
} from '../../utils/allTableTab';
import { handleDeletePaymentMethods } from '../../utils/depositUtils';
import { handleLatestData } from '../../utils/getLeadLatestData';
import { localStorageRemoveItem } from '../../utils/storage-available';
// style
import { common, grey, primary } from '../../theme/palette';
import {
    stackStyle,
    textFieldStyle,
    searchWrapperStyle,
    tabsStyle,
    tabStyle,
    cancelBtnStyle,
    yesBtnStyle,
    treatmentBoxStyle,
    referralBoxStyle,
    treatmentTagFilterStyle,
    filterFormBoxStyle,
    referralOutBoxStyle,
    searchFilterContent,
    zIndexStyle,
    borderRadiosStyle,
    dialogTitleStyle,
    dialogActionStyle,
} from '../../styles/NewLead';
import ChangePracticePopover from './tables/AllLeadTable/ChangePracticePopover';


const NewLead = ({
    leadData,
    updateLeadPage,
    pageCount,
    type,
    setUpdateList,
    tableTitle,
    counter,
    reloadCounter,
    reloadTaskCounter,
    onClose,
    rowStatus,
    defaultHideColumn,
    columnVisibilityModel,
    handleColumnVisibilityChange,
    handleColumnOrderChange,
    shouldRunEffect,
    dashBoardDateProps,
    isNoTaskLeadsTable,
    selectedTab,
    setColumnVisibilityModel,
    pinProps,
    displayForCategorySummary,
    leadCategoryType,
    forceReload,
    archiveReasonData,
    showPracticeColumn,
    onDateRangeReady,
    widgetToggle: widgetToggleProp,
    hideCounterTabs,
    isCombinedName,
    handleToggleCombineName,
    setIsCombinedName,
    initialBookedWidgetFilter,
    isEnforcedByPractice,
    setIsEnforcedByPractice,
    // When the wrapper page renders ONE NewLead and uses a top-level Tabs strip
    // to switch among slice-sharing views (built-in board + treatment-scoped
    // custom tabs), pass the active customTabId in here. NewLead resets pagination
    // and fires a refetch whenever the prop changes. Leave undefined for the
    // legacy/standalone case where NewLead manages its own custom-tab strip
    // (Newest Leads inline custom tabs, etc.) — that path is unchanged.
    // null  = built-in board (no custom-tab scope)
    // Number = a specific PracticeCustomTableTab id
    controlledCustomTabId,
    // Bug 2c fix: URL-driven inner checklist strip state. ConsultantAttend passes
    // ?checklist_state= from the URL so this value is the single source of truth
    // on browser-back, preventing the Redux initialState 'in_progress' from racing.
    // null / undefined means no URL override — use Redux as normal.
    checklistStateFromUrl = null,
    // Callback to write checklistState back to the URL when the strip changes.
    // Called with the new state string ('in_progress' | 'complete').
    onChecklistStateChange = null,
}) => {
    const practiceId = useSelector((state) => state.practiceTreatmentList.practiceId);
    // Custom treatment-scoped sub-tabs (loaded once per practice; appended to the
    // parent table's tab strip below). See spec:
    // docs/superpowers/specs/2026-05-01-custom-treatment-sub-tabs-design.md
    const customTabs = useSelector((s) => selectCustomTabsForParent(s, practiceId, tableTitle), shallowEqual);
    const practiceTreatment = useSelector((state) => state.practiceTreatmentList.practiceTreatment);
    // Subscribe to the All-Practices selection so this component re-
    // renders and re-fires its reload effects whenever the user flips
    // the multi-practice selector. Without this subscription, thunks
    // that read `activePracticeIds` via `store.getState()` use the new
    // value on their NEXT dispatch (route change, filter change) — but
    // an active lead table doesn't know to refetch just because the
    // selection changed. Adding this to the reload-effect deps below
    // closes that reactivity gap (P1 from phase-4 review).
    const activePracticeIds = useSelector(
        (state) => state.practiceTreatmentList?.activePracticeIds,
    );
    // Serialise to a stable string so the useEffect dep compare is
    // value-based rather than reference-based (arrays are new on every
    // Redux state emit, which would fire the effect even without a
    // real change).
    const activePracticeIdsKey = Array.isArray(activePracticeIds)
        ? activePracticeIds.join(',')
        : '';
    const { handleTableData } = useLeadTableHelper(type);
    const { page, order, orderBy, setPage, rowsPerPage, onChangePage, onChangeRowsPerPage, setRowsPerPage } = useTable({
        defaultOrder: 'desc',
    });
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
    });
    const location = useLocation();
    const currentPagePath = location.pathname;
    const { initialFilters, syncToUrl, hasUrlFilters } = useTableQueryParams();
    const theme = useTheme();
    const isLight = theme.palette.mode === 'light';
    const [mobileFiltersExpanded, setMobileFiltersExpanded] = useState(false);
    const isMobileFilters = useMediaQuery('(max-width:768px)');
    const rowData = [];

    const inputRef = useRef();
    const personalDetailPopupRef = useRef();
    const rowLead = useRef();

    const { enqueueSnackbar } = useSnackbar();
    const [currentWidget, setCurrentWidget] = useState('1');

    const picker = useDateRangePicker(null, null);
    const message = useSelector((state) => state.practiceTreatment.message);
    const error = useSelector((state) => state.practiceTreatment.error);
    const activityList = useSelector((state) => state.activity.activityList);
    const results = useSelector((state) => state.practiceTreatment?.treatmentsList?.results);
    const categoryList = useSelector((state) => state.practiceTreatment.categoryList);
    const practiceUser = useSelector((state) => state.practiceUser.practiceUser);
    const practice = useSelector((state) => state.practice.practice);
    // Phase 2 cascade: system-default global table prefs (renames + hidden_tabs)
    // fall back here when the practice has no override.
    const globalTablePreferencesForStrip = useSelector((state) => state.tablePreferences?.globalTablePreferences);
    const { dentallyEnabledGlobal } = useSelector((state) => state.practice);
    const baseHiddenFilters = [
        ...(practice?.preferences?.hidden_filters?.[tableTitle] || []),
        ...(practice?.preferences?.hidden_filters?._table_filters?.[tableTitle] || []),
    ];
    const { pmsEnabledGlobal } = useSelector((state) => state.pmsSchedule);
    const isDentallyBooking = useSelector((state) => state.lead.isDentallyBooking);
    const loadingForLead = useSelector(selectLoadingForLead);
    const referralData = useSelector((state) => state.schema.referral);
    const [currentTreatmentData, setCurrentTreatmentData] = useState({});
    const isPaymentMandatory = practice?.preferences?.is_payment_enforced_before_treatment;
    const [depositStatus, setDepositStatus] = useState(false);
    const [practiceListMap, setPracticeListMap] = useState({});
    const isAppointmentBooked = useSelector(selectIsAppointmentBooked);
    const attendance = useSelector(selectAttendance);
    const followUpLead = useSelector(selectFollowUpLead);
    const followLead = useSelector(selectFollowLead);
    const markAsComplete = useSelector(selectMarkAsComplete);
    const contactLead = useSelector(selectContactLead);
    const BookingAttendance = useSelector(selectBookingAttendance);
    const multiLead = useSelector(selectMultiLead);
    const taskTableData = useSelector(selectTaskTableData);
    const { limit, offset, filter, assignUser } = taskTableData || {};
    const action = useSelector(selectAction);
    const isLoader = useSelector((state) => state.loaderReducer.isLoader);
    const getUserList = () => practiceUser.results.filter((el) => el.user && el.user.first_name && !el.user.is_superuser);
    const superData = useSelector((state) => state.superAdmin.superData);

    const orderByValue = orderBy === 'name' ? 'created_at' : orderBy;
    const allType = type === 'Dashboard' || type === 'NoTaskTable';
    const notAllType = type !== 'Dashboard' && type !== 'NoTaskTable';
    const newType = type === 'NewLeadTable';
    const dashType = type === 'DashNewLeadTable';
    const noDashType = type !== 'DashNewLeadTable';
    const archType = type === 'ArchiveTable';
    const notArchType = type !== 'ArchiveTable';
    const consultantAttendedType = type === 'ConsultantAttend';
    const attendedChecklistsType = type === 'AttendedChecklists';
    const consultantClinCheckAttendedType = type === 'ConsultantClinCheckAttend';
    const notClinCheckType = type !== 'ConsultantClinCheckAttend';
    const consultantBookedType = type === 'ConsultantBooked';
    const noConsultantBookedType = type !== 'ConsultantBooked';
    const treatmentStartedType = type === 'treatmentStarted' || type === 'treatmentStartedWithInvisalign';
    const noTreatmentStartedType = type !== 'treatmentStarted';
    const failedToAttendType = type === 'FailedToAttend';
    const noFailedToAttendType = type !== 'FailedToAttend';
    const noClosedType = type !== 'Closed';
    const isReportData = type !== 'reportTableData';
    const reportData = type === 'reportTableData';
    const commonType = notArchType && noFailedToAttendType && noClosedType;
    const bookedWithFilter = consultantAttendedType || attendedChecklistsType || consultantClinCheckAttendedType || consultantBookedType || treatmentStartedType;

    const contactCount = TabCount(type);
    const pageNumber = TablePageNumber(type);
    const perPage = TablePerPage(type);
    const searchValue = TableSearch(type);
    const treatmentValue = TableTreatment(type);
    const assigneeSelectedForFilter = TableAssignees(type);
    const searchFilterDate = TableFilterDate(type);
    const tableStatus = TableStatus(type);
    const searchTags = TableFilterTags(type)?.toString();
    const tableOrder = TableOrder(type);
    const tableOrderBy = TableOrderBy(type);
    const referral = TableReferral(type);
    const depositPendingStatus = TableDepositPending(type);
    const contactedCountFilterValue = TableContactedCountFilter(type);
    // Bug 2c: URL param takes precedence over Redux on browser-back.
    // checklistStateFromUrl is null for tables that don't use URL-driven state
    // (TreatmentStarted, AttendedChecklists, etc.) — no behaviour change for them.
    const checklistStateValue = checklistStateFromUrl || TableChecklistState(type);
    const category = TableCategory(type);
    const categoryName = TableCategoryName(type);
    const bookedWith = TableBookedWith(type);
    const searchFilterTags = TableTags(type);
    const { consultationBookedWith, apptType } = TableConsultationBookedWith(type);
    const archiveReason = TableArchiveReason(type);
    const practices = TablePracticeFilter(type);

    // Date fallback: Redux → sessionStorage → null (show all)
    const sessionDateKey = `dsem_dateRange_${type}`;
    const sessionDates = (() => { try { return JSON.parse(sessionStorage.getItem(sessionDateKey)); } catch { return null; } })();
    // Check .length: an empty array [] is truthy but [0] is undefined, causing
    // "Cannot read 'startDate' of undefined" (Sentry: REACT-DC, 6 users, 24 events).
    const startDate = searchFilterDate?.length > 0 ? searchFilterDate[0]?.startDate : (sessionDates?.startDate || null);
    const endDate = searchFilterDate?.length > 0 ? searchFilterDate[0]?.endDate : (sessionDates?.endDate || null);

    const hasActiveFilters = Boolean(
        searchValue ||
        treatmentValue?.length > 0 ||
        startDate ||
        endDate ||
        referral?.length > 0 ||
        bookedWith?.length > 0 ||
        depositPendingStatus ||
        consultationBookedWith?.length > 0 ||
        assigneeSelectedForFilter?.length > 0 ||
        archiveReason?.length > 0 ||
        practices?.length > 0
    );

    const buildUrlFilterState = (overrides = {}) => {
        const state = {};
        const sv = overrides.search !== undefined ? overrides.search : searchValue;
        if (sv) state.search = sv;
        const tv = overrides.treatment !== undefined ? overrides.treatment : treatmentValue;
        if (tv?.length) state.treatment = tv;
        const rv = overrides.referral !== undefined ? overrides.referral : referral;
        if (rv) state.referral = rv;
        const sd = overrides.startDate !== undefined ? overrides.startDate : startDate;
        const ed = overrides.endDate !== undefined ? overrides.endDate : endDate;
        if (sd) state.startDate = sd;
        if (ed) state.endDate = ed;
        const dp = overrides.depositPaid !== undefined ? overrides.depositPaid : depositPendingStatus;
        if (dp) state.depositPaid = dp;
        const bw = overrides.bookedWith !== undefined ? overrides.bookedWith : bookedWith;
        if (bw?.length) state.bookedWith = bw;
        const cbw = overrides.consultationBookedWith !== undefined ? overrides.consultationBookedWith : consultationBookedWith;
        if (cbw?.length) state.consultationBookedWith = cbw;
        const asn = overrides.assignee !== undefined ? overrides.assignee : assigneeSelectedForFilter;
        if (asn?.length) state.assignee = asn;
        const ar = overrides.archiveReason !== undefined ? overrides.archiveReason : archiveReason;
        if (ar) state.archiveReason = ar;
        const tgs = overrides.tags !== undefined ? overrides.tags : searchFilterTags;
        if (tgs?.length) state.tags = tgs;
        const nt = overrides.noTreatment !== undefined ? overrides.noTreatment : false;
        if (nt) state.noTreatment = true;
        return state;
    };

    const open = useBoolean();
    const openBulkReminder = useBoolean();

    const paymentDeleteToggle = useToggle();

    const [tableData, setTableData] = useState(leadData);
    const [validStep, setValidStep] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const shouldCallReminder = useRef(true);
    const [active, setActive] = useState(0);
    const [searchQuery, setSearchQuery] = useState(decodeURIComponent(searchValue) || null);
    const [search, setSearch] = useState(decodeURIComponent(searchValue) || '');
    const [startConfirmation, setStartConfirmation] = useState(false);
    const [startTreatment, setStartTreatment] = useState('');
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [checkOptions, setCheckOptions] = useState(false);
    const [headings, setHeading] = useState([]);
    const [date, setDate] = useState([startDate, endDate]);
    const [userList, setUserList] = useState([]);
    const [filters, setFilters] = useState([]);
    const [, setDepositPendingFilter] = useState('');
    const [assignees, setAssignees] = useState([]);
    const [anchorEditTreatment, setAnchorEditTreatment] = useState(null);
    const [anchorPractice, setAnchoranchorPractice] = useState(null);
    // Bug 1 fix: explicit busy gate for checklist-strip tab switches.
    // Set true when handleChangeChecklistState fires; cleared by NewLeadDataGrid
    // once BOTH the new rows AND their checklist cells have resolved.
    // Scoped to this path only — does NOT change handleLoading's 500ms for all tables.
    const [isChecklistSwitching, setIsChecklistSwitching] = useState(false);

    const treatmentData = [];
    treatmentValue?.map((value) => treatmentData.push(value.id));

    const assigneeData = [];
    assigneeSelectedForFilter?.map((value) => assigneeData.push(value.id));

    const bookedWithData = [];
    if (Array.isArray(bookedWith)) {
        bookedWith.map((value) => bookedWithData.push(value?.id));
    }

    const consultationBookedWithData = [];
    if (Array.isArray(consultationBookedWith)) {
        consultationBookedWith.map((value) => consultationBookedWithData.push(value?.id));
    }

    const noAwatingCount = counter?.filter((value) => value.filterStatus === 'AWAITING_RESPONSE');
    const nhsCount = counter?.filter((value) => value.filterStatus === 'NHS');
    const [appoinmentSelectData, setAppoinmentSelectData] = useState(null);
    const [forceUpdate, setForceUpdate] = useState(false);
    const [anchorElAssign, setAnchorElAssign] = useState(null);
    const [appoinmentSelectedId, setAppoinmentSelectedId] = useState(null);
    const [anchorClinCheck, setAnchorClinCheck] = useState(null);
    const [anchorDepositPayment, setAnchorDepositPayment] = useState(null);
    const tableRowLead = useSelector(selectTableRowLead);
    const [contactLeadDefaultTab, setContactLeadDefaultTab] = useState('overview');
    const [bookedWidgetFilter, setBookedWidgetFilter] = useState(initialBookedWidgetFilter || null);

    // Dentally follow-up booking state
    const [dentallySlot, setDentallySlot] = useState(null);
    const [selectedDentallyTreatment, setSelectedDentallyTreatment] = useState(null);
    const [dentallyAssignees, setDentallyAssignees] = useState([]);
    const [followUpConfirmStepState, setFollowUpConfirmStepState] = useState({});
    const [useDentallyFlow, setUseDentallyFlow] = useState(true);
    // PMS scheduling state
    const [pmsSlot, setPmsSlot] = useState(null);
    const [pmsPractitioner, setPmsPractitioner] = useState(null);
    const [pmsDate, setPmsDate] = useState(null);
    const [pmsConfirmStepState, setPmsConfirmStepState] = useState({});
    const handleToggleBookingMode = useCallback((useDentally) => {
        setUseDentallyFlow(useDentally);
        if (!useDentally) {
            setDentallySlot(null);
            setSelectedDentallyTreatment(null);
            setDentallyAssignees([]);
        }
    }, []);

    const {
        toggle: openTreatmentEditPopup,
        onOpen: onopenTreatmentEditPopup,
        onClose: onCloseTreatmentEditPopup,
    } = useToggle();

    const {
        toggle: openPracticePopup,
        onOpen: onopenPracticePopup,
        onClose: onClosePracticePopup,
    } = useToggle();

    const {
        toggle: openDepositPaymentPopup,
        onOpen: onOpenDepositPaymentPopup,
        onClose: onCloseDepositPaymentPopup,
    } = useToggle();

    // Serialize to JSON so these memos are stable against new practice object
    // references from Redux updates that don't change the actual content.
    // Using the raw object as a dep causes re-fires on every practice field update
    // (notifications, preferences, etc) — which rebuilds headings, re-locks the
    // active-tab indicator, and (when combined with setHeading) can infinite-loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const tableTabsHiddenMap = useMemo(
        () => practice?.preferences?.hidden_filters?._table_tabs || null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(practice?.preferences?.hidden_filters?._table_tabs)],
    );

    // Memoized so the first setHeading effect doesn't need `practice` in its deps
    // (practice changes reference on every Redux update, which would loop).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const isAcceptingNhs = useMemo(
        () => practice?.preferences?.is_accepting_nhs_patients ?? false,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(practice?.preferences?.is_accepting_nhs_patients)],
    );

    useEffect(() => {

        if (type) {
            switch (type) {
                case 'treatmentStarted':
                    // No treatment category tabs for Treatment Started table
                    setHeading([]);
                    break;
                case 'treatmentStartedWithInvisalign': {
                    // Filter categories to only those with at least one enabled treatment in this practice
                    const categories = categoryList?.results;
                    if (categories && results?.length > 0) {
                        const activeCategoryIds = new Set(
                            results.map((t) => t?.treatment_item?.treatment_category?.id).filter(Boolean)
                        );
                        setHeading(categories.filter((cat) => cat.id === '0' || activeCategoryIds.has(cat.id)));
                    } else {
                        setHeading(categories);
                    }
                    break;
                }
                case 'NewLeadTable':
                case 'DashNewLeadTable': {
                    // Practice-level admin can hide individual category sub-tabs via
                    // `_table_tabs['Newest Leads']`. Slugs mapped to DASH_NEW_HEADER values:
                    //   '0' → category-new · 'NHS' → category-nhs · 'AWAITING_RESPONSE' → category-awaiting
                    //   '1' → follow-up-1 · '2' → follow-up-2 · '3' → follow-up-3
                    const newestHidden = tableTabsHiddenMap?.['Newest Leads'] || [];
                    const newestSlug = {
                        '0': 'category-new',
                        NHS: 'category-nhs',
                        AWAITING_RESPONSE: 'category-awaiting',
                        '1': 'follow-up-1',
                        '2': 'follow-up-2',
                        '3': 'follow-up-3',
                    };
                    const baseHeader = isAcceptingNhs
                        ? DASH_NEW_HEADER
                        : DASH_NEW_HEADER.filter((e) => e.value !== 'NHS');
                    setHeading(
                        baseHeader.filter((h) => {
                            const slug = newestSlug[String(h.value)];
                            return !slug || !newestHidden.includes(slug);
                        }),
                    );
                    break;
                }
                case 'ConsultantAttend': {
                    // Single "All Attended" tab. Admin can hide the 'attended' slug via
                    // _table_tabs['Consultation Attended Leads'] — honour it.
                    // Reported by Raj 2026-05-25 — disable wasn't reflected on FE.
                    const attendedHidden = tableTabsHiddenMap?.['Consultation Attended Leads'] || [];
                    setHeading(
                        attendedHidden.includes('attended') ? [] : CONSULTANT_ATTENDED_SINGLE_HEAD,
                    );
                    break;
                }
                case 'AttendedChecklists':
                    setHeading(ATTENDED_CHECKLISTS_TAB_HEAD);
                    break;
                case 'ConsultantClinCheckAttend':
                    setHeading(CONSULTANT_CLINCHECK_ATTENDED_HEAD);
                    break;
                case 'ConsultantBooked':
                    setHeading(CONSULTANT_BOOKED_HEAD);
                    break;
                case 'NoTaskTable': {
                    // Status strip on the No Task Assigned table — admin-controllable
                    // via `_table_tabs['No Task Assigned']`. Slugs map to TAB_HEAD_NO_TASK values.
                    const noTaskHidden = tableTabsHiddenMap?.['No Task Assigned'] || [];
                    const noTaskSlug = {
                        NEW: 'status-new',
                        FOLLOW_UP: 'status-follow-up',
                        CONSULTATION_BOOKED: 'status-consultation-booked',
                        CONSULTATION_ATTENDED: 'status-consultation-attended',
                        FAILED_TO_ATTEND_CONSULTATION: 'status-fta',
                    };
                    setHeading(
                        TAB_HEAD_NO_TASK.filter((h) => {
                            const slug = noTaskSlug[String(h.value)];
                            return !slug || !noTaskHidden.includes(slug);
                        }),
                    );
                    break;
                }
                default:
                    setHeading(TAB_HEAD_FOLLOW_UP);
                    break;
            }
        }
    }, [type, categoryList?.results, tableTabsHiddenMap, isAcceptingNhs, results]);

    // Serialize to JSON so the memo only recomputes when content changes, not when
    // the practice object gets a new reference on every Redux update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const tabOrderOverrides = useMemo(
        () => practice?.preferences?.tab_order_overrides || null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(practice?.preferences?.tab_order_overrides)],
    );

    // Append custom treatment-scoped sub-tabs to the parent table's tab strip.
    // Runs after the type-switch above sets the base headings; harmless when
    // there are no custom tabs.
    useEffect(() => {
        if (!customTabs?.length) return;
        const visible = customTabs
            .filter((t) => {
                if (t.is_hidden) return false;
                // Tabs with placement='top' render at the top-level tab row via the
                // parent page component (e.g. ConsultantAttend.jsx), NOT in the
                // inline category strip. Skip them here so they don't appear twice.
                if (t.placement === 'top') return false;
                const treatments = t.practice_treatments || [];
                const mode = t.treatment_scope_mode || 'include';
                // Empty practice_treatments can mean different things by mode:
                //   - include + no treatments     → 'all treatments' (BE shows all leads)
                //   - exclude + no treatments     → nothing excluded, optionally sibling-based
                //   - exclude + sibling refs only → live-resolved at BE
                //   - all (legacy)                → show
                // Trust the BE custom_table_tab filter (#125 wired) to decide leads;
                // FE should only hide the strip entry when admin marked is_hidden=true.
                if (mode === 'include' && treatments.length > 0) {
                    // Hide a tab when EVERY chosen treatment is disabled.
                    const allDisabled = treatments.every((pt) => pt?.enabled === false);
                    if (allDisabled) return false;
                }
                return true;
            })
            .map((t) => ({
                value: `custom:${t.id}`,
                // labelCount() reads `data.name` for treatmentStartedType and
                // `data.label` for everyone else, so we set both. The • suffix
                // signals an active predicate filter on the dashboard.
                name: t.attribute_predicate ? `${t.name} •` : t.name,
                label: t.attribute_predicate ? `${t.name} •` : t.name,
                // For treatmentStartedType the Tab uses item.id as key/value;
                // mirror our synthetic value to id so it survives that path.
                id: `custom:${t.id}`,
                isCustomTab: true,
                customTabId: t.id,
                hasPredicate: !!t.attribute_predicate,
            }));
        // Prepend a synthetic "All" tab on every parent that has custom tabs, so
        // users have a reset button regardless of how many categories the admin
        // has hidden. 'treatmentStartedWithInvisalign' already has an "All" entry
        // from the categoryList Redux fetch, so we skip injecting there to avoid
        // a duplicate.
        const typeToParent = {
            treatmentStarted: 'Treatment Started Leads',
            ConsultantAttend: 'Consultation Attended Leads',
            NewLeadTable: 'Newest Leads',
            DashNewLeadTable: 'Newest Leads',
            NoTaskTable: 'No Task Assigned',
            AttendedChecklists: 'Attended Checklists',
            ConsultantBooked: 'Consultation Booked Leads',
            ConsultantClinCheckAttend: 'Consultation ClinCheck Leads',
        };
        const parentName = typeToParent[type];
        const parentHidden = parentName ? (tableTabsHiddenMap?.[parentName] || []) : [];
        const needsAllTab = !!parentName
            && type !== 'treatmentStartedWithInvisalign'
            // Post-#104 Attended is a single flat tab — no Follow-up sub-tabs, so no
            // reset button is needed. ConsultantAttend.jsx renders the parent top strip
            // (built-in + custom only); the inner heading must not inject an All here either.
            && type !== 'ConsultantAttend'
            // Treatment Started has no native sub-tab strip and the synthetic "All"
            // confused users (per #58/#118 follow-up). Skip injecting it here.
            && type !== 'treatmentStarted'
            && !parentHidden.includes('all');
        // Value is 'All' (capital) to match the existing coreThunks sentinel for
        // "no contact-count filter" — keeps the active-tab highlight working when
        // contactCount is set to 'All' on click.
        const allTab = needsAllTab
            ? { value: 'All', label: 'All', name: 'All', id: 'All' }
            : null;
        // Apply saved tab order from admin V2 page (tab_order_overrides keyed by parentName).
        // I2: use full slug positions — custom-N slugs for custom tabs, raw slug for built-ins.
        const tabOrder = parentName ? (tabOrderOverrides?.[parentName] || []) : [];
        let orderedVisible = visible;
        if (tabOrder.length > 0) {
            const posMap = Object.fromEntries(tabOrder.map((slug, i) => [slug, i]));
            orderedVisible = [...visible].sort((a, b) => {
                // custom tabs keyed as "custom-<id>"; built-in tabs keyed by their raw slug value
                const slugA = a.isCustomTab ? `custom-${a.customTabId}` : (a.value || a.id || '');
                const slugB = b.isCustomTab ? `custom-${b.customTabId}` : (b.value || b.id || '');
                const pa = posMap[slugA] ?? Infinity;
                const pb = posMap[slugB] ?? Infinity;
                return pa - pb;
            });
        }
        // Bail only when there's genuinely nothing to inject. When every custom
        // tab on this parent is placement='top' the inline `visible` array is
        // empty, but we still need to inject the synthetic All so the admin's
        // 'all' slug toggle isn't a dead switch on those parents.
        if (!orderedVisible.length && !allTab) return;
        setHeading((prev) => {
            const existingIds = new Set((prev || []).map((h) => h?.value));
            const additions = orderedVisible.filter((v) => !existingIds.has(v.value));
            const prefix = allTab && !existingIds.has('All') ? [allTab] : [];
            if (!additions.length && !prefix.length) return prev;
            return [...prefix, ...(prev || []), ...additions];
        });
        // Re-run when the custom tab list, table type, hidden map, or tab ordering
        // changes. `results` is intentionally excluded — it is only needed by the
        // first setHeading effect (treatmentStartedWithInvisalign category filter)
        // and including it here caused an infinite loop: results gets a new array
        // reference on every render, which re-fires this effect, which calls
        // setHeading, which triggers a re-render → Maximum update depth exceeded.
    }, [customTabs, type, categoryList?.results, tableTabsHiddenMap, tabOrderOverrides]);

    const currentTreatmentDataGlobal = useSelector((state) => state.multiTreatment.currentTreatmentDataGlobal);

    useEffect(() => {
        if (!isEmpty(currentTreatmentDataGlobal)) {
            dispatch(setCurrentTreatmentDataGlobal(null));
        }
        if (action) {
            dispatch(setAction(null));
        }
        // dispatch(initializeFacebookAuthToken());
        return () => (dispatch(updateLeadDataCount(false)));
    }, []);

    useEffect(() => {
        if (type) {
            dispatch(updateTableType(type));
        }
    }, [type]);

    // When the wrapper switches among slice-sharing views (built-in vs custom-top
    // tabs that all share the same Redux slice + type), reset pagination and fire
    // a fetch with the new scope. Mirrors handleChangeStatus's 'All' reset block
    // (NewLead.jsx ~L1495-1518) one-for-one so user-set filters (deposit, search,
    // treatments, tags, etc.) survive a top-strip switch — only contactCount,
    // category, and customTabId change.
    //
    // The ref guards the initial render so the wrapper's own first fetch isn't
    // doubled up.
    //
    // Race caveat: if the user switches tabs faster than the network round-trip,
    // a stale response for tab N can land after a newer response for tab N+1.
    // End state is correct (slice always reflects the LAST response, which always
    // corresponds to the LAST click), so the user sees the right data after the
    // newer fetch resolves. Same architecture as Newest Leads inline custom tabs,
    // which has run in prod without user-visible regressions.
    const prevControlledCustomTabIdRef = useRef(controlledCustomTabId);
    useEffect(() => {
        if (controlledCustomTabId === undefined) return; // legacy / standalone NewLead
        if (prevControlledCustomTabIdRef.current === controlledCustomTabId) return; // no change
        prevControlledCustomTabIdRef.current = controlledCustomTabId;
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        if (practiceId) {
            // When the incoming custom tab has a checklist_binding, default the
            // sub-strip to 'in_progress' so the green underline lands on "In Progress"
            // and the initial fetch includes checklist_state=in_progress — matching
            // the standalone AttendedChecklists route behaviour (commit d38622b2).
            // When switching away (null or non-checklist tab), clear checklistState
            // so the inline category strip resumes its normal contactedCount logic.
            const incomingTab = controlledCustomTabId != null
                ? customTabs?.find?.((t) => Number(t.id) === Number(controlledCustomTabId)) || null
                : null;
            const incomingIsChecklist = !!(incomingTab?.checklist_binding?.template_ids?.length);
            // defaultCount drives the first-strip underline (UpdateTableData count key).
            // Task #100 Risk 2: with the additive two-strip layout, the
            // contacted-count strip lands on "All" and the checklist strip lands
            // on "In Progress" by default — both render side by side.
            const defaultCount = 'All';
            // Bug 2c fix: if the URL carries a restored checklistState (browser-back),
            // use it instead of forcing 'in_progress'. This prevents the
            // controlledCustomTabId effect from overwriting a URL-restored 'complete'
            // with the default 'in_progress' value on remount.
            // checklistStateFromUrl is null for fresh navigations → falls back to 'in_progress'.
            const defaultChecklistState = incomingIsChecklist ? (checklistStateFromUrl || 'in_progress') : '';
            // Checklist-bound tabs derive their treatment scope from customTabId in
            // coreThunks — forwarding treatmentData here would add a spurious
            // lead_treatments__treatment__in param that mismatches the badge counter
            // (which also doesn't include a treatment filter on initial load).
            const treatmentForTab = incomingIsChecklist ? undefined : treatmentData?.toString();
            updateLeadPage({
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder || 'desc',
                orderId: tableOrderBy || 'created_at',
                searchQuery: searchValue,
                treatment: treatmentForTab,
                startDate,
                endDate,
                contactedCount: 'All',
                checklistState: defaultChecklistState,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                category: '0',
                archiveReason,
                noTreatment: false,
                customTabId: controlledCustomTabId === null ? undefined : controlledCustomTabId,
            });
            const tableUpdateData = { count: defaultCount, checklistState: defaultChecklistState, category: '0', categoryName: '', perPage: 10, pageNumber: 0 };
            if (incomingIsChecklist) tableUpdateData.treatment = [];
            UpdateTableData(type, tableUpdateData);
            if (reloadCounter) {
                reloadCounter({
                    limit: 10,
                    offset: 0,
                    order: tableOrder || 'desc',
                    orderId: tableOrderBy || 'created_at',
                    searchQuery: searchValue,
                    treatment: treatmentForTab,
                    startDate,
                    endDate,
                    contactedCount: 'All',
                    checklistState: defaultChecklistState,
                    tags: searchTags,
                    referral,
                    depositPendingStatus,
                    bookedWith: bookedWithData?.toString(),
                    assigneeIds: assigneeData?.toString(),
                    noTreatment: false,
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controlledCustomTabId, practiceId]);

    useEffect(() => {
        if (hasUrlFilters && type) {
            const urlData = {};
            if (initialFilters.search) urlData.search = encodeURIComponent(initialFilters.search);
            if (initialFilters.referral) urlData.referral = initialFilters.referral;
            if (initialFilters.startDate && initialFilters.endDate) {
                urlData.date = [{ startDate: initialFilters.startDate, endDate: initialFilters.endDate }];
            }
            if (initialFilters.depositPaid) urlData.depositPendingStatus = initialFilters.depositPaid;
            if (initialFilters.archiveReason) urlData.archiveReason = initialFilters.archiveReason;
            if (Object.keys(urlData).length > 0) {
                UpdateTableData(type, urlData);
            }
            if (initialFilters.search) {
                setSearch(initialFilters.search);
                setSearchQuery(initialFilters.search);
            }
        }
    }, []);

    const debouncedValue = useDebounce(searchValue, 300);

    const onSubmit = (data) => setValidStep(!!data);

    const handleReloadLeads = () => {
        const reloadPayLoad = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false
        };
        updateLeadPage(reloadPayLoad);
    };

    // Stable callback passed to NewLeadDataGrid for post-completion refresh.
    // Captures current filter state so checklist YES / undo don't wipe active filters.
    const refreshTableWithCurrentFilters = useCallback(() => {
        const payload = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            // When on a checklist sub-tab, contactCount holds 'in_progress' or 'complete'
            // (same Redux slot as contacted-count). Passing it as contactedCount would
            // produce a bogus contacted_count_for_status filter that overwrites the
            // checklist_state filter. Match the logic in handleChangeStatus checklist path.
            contactedCount: checklistStateValue ? 'All' : contactCount,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            forceRefetch: true,
        };
        updateLeadPage(payload);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [perPage, pageNumber, tableStatus, tableOrder, tableOrderBy, searchQuery, treatmentData, startDate, endDate, contactCount, checklistStateValue, searchTags, referral, practices, depositPendingStatus, bookedWithData, assigneeData, archiveReason, tableData, practiceId]);

    // Cheaper variant: only re-fetches badge counts, not the full list.
    // Used on every YES so badges update immediately without a table flash.
    const refreshCountersOnly = useCallback(() => {
        if (!(tableData && practiceId && reloadCounter)) return;
        reloadCounter({
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: checklistStateValue ? undefined : treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: checklistStateValue ? 'All' : contactCount,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            forceRefetch: true,
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [perPage, pageNumber, tableStatus, tableOrder, tableOrderBy, searchQuery, treatmentData, startDate, endDate, contactCount, checklistStateValue, searchTags, referral, practices, depositPendingStatus, bookedWithData, assigneeData, archiveReason, tableData, practiceId]);

    // Splice a lead row out of the local table state immediately (optimistic).
    // Returns { row, index } for later restore on undo.
    const removeRowOptimistically = useCallback((leadId) => {
        let removed = null;
        setTableData((prev) => {
            const idx = prev.findIndex(
                (r) => String(r.id) === String(leadId) || String(r.lead_id) === String(leadId)
            );
            if (idx === -1) return prev;
            removed = { row: prev[idx], index: idx };
            return [...prev.slice(0, idx), ...prev.slice(idx + 1)];
        });
        return removed;
    }, []);

    // Re-insert a previously removed row at its original index.
    const restoreRowOptimistically = useCallback((row, index) => {
        setTableData((prev) => {
            const insertAt = Math.min(index, prev.length);
            return [...prev.slice(0, insertAt), row, ...prev.slice(insertAt)];
        });
    }, []);

    // Bulk checklist-complete machinery — mirrors the single-lead path in makeOnChecklistComplete:
    //   refreshCounters (badge update) → per-lead exit animation via NewLeadDataGrid → 6.5 s reconcile.
    // The grid registers its animator via setBulkCompleteAnimate (see onBulkCompleteReady prop below).
    const bulkCompleteAnimateRef = useRef(null);
    const setBulkCompleteAnimate = useCallback((fn) => {
        bulkCompleteAnimateRef.current = fn;
    }, []);

    const handleBulkComplete = useCallback((completedLeadIds) => {
        refreshCountersOnly();
        completedLeadIds.forEach((leadId) => {
            if (bulkCompleteAnimateRef.current) {
                bulkCompleteAnimateRef.current(leadId);
            } else {
                // Grid not mounted (edge-case): fall back to instant removal.
                removeRowOptimistically(leadId);
            }
        });
        // Reconcile: re-fetch after rows have animated out + server has settled.
        setTimeout(refreshTableWithCurrentFilters, 6500);
    }, [refreshCountersOnly, removeRowOptimistically, refreshTableWithCurrentFilters]);

    // P0 — Persistent skip-group surface.
    // Stores the grouped skip info returned by bulkChecklistAction when bulk Complete
    // encounters non-BULK_COMPLETABLE item types.  Null = dialog hidden.
    // Each group is an array of lead-ID strings whose items of that type were skipped.
    // The dialog is cleared only by explicit "Got it" — never auto-dismissed.
    const [skipGroups, setSkipGroups] = useState(null);

    const handleItemsSkipped = useCallback((groups) => {
        const hasAny = groups && Object.values(groups).some((ids) => ids.length > 0);
        if (hasAny) setSkipGroups(groups);
    }, []);

    const handleClose = (status, data) => {
        dispatch(setLoader(false));
        const reloadPayLoad = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false
        };

        if (status?.toLowerCase?.() === 'finish' && followUpLead !== 'restoreArchived') {
            dispatch(updateCounter([]));
            updateLeadPage(!isEmpty(data) && isPlainObject(data) ? data : reloadPayLoad);
            dispatch(getLeadReminderData(practiceId, 'dashboard', limit, offset, filter, '', assignUser, '', '', '', '', '', '', '', ''));
            if (reloadTaskCounter) {

                reloadTaskCounter(assignUser);
            }
            if (dashType || newType) {
                dispatch(dashNewTableCounter(practiceId));
            }
            if (reloadCounter) {
                reloadCounter(typeof data === 'object' ? data : reloadPayLoad);
            }
        }
        open.onFalse();
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateSteps(null));
        dispatch(updateFollowUpLead(null));
        onCloseFollowLead();
        onCloseConsultationAttend();
        onCloseRecordAttend();
        onCloseUnRecordAttend();
        onCloseArchiveLead();
        onCloseRestoreArchived();
        closeDuplicatePopup();
        closeUnMarkAsDuplicate();
        closeMarkAsSpamDialog();
        setStartTreatment('');
        onCloseContactLead();
        setContactLeadDefaultTab('overview');
        setStartConfirmation(false);
        dispatch(setCallScriptSection(null));
        setAnchorClinCheck(null);
        // Reset Dentally follow-up booking state
        setDentallySlot(null);
        setSelectedDentallyTreatment(null);
        setDentallyAssignees([]);
        // Reset PMS scheduling state
        setPmsSlot(null);
        setPmsPractitioner(null);
        setPmsDate(null);
        setUseDentallyFlow(true);
        setForceUpdate((prev) => !prev);
        handleReloadLeads();
    };

    useEffect(() => {
        if (forceReload) {
            handleReloadLeads();
        }
    }, [forceReload]);

    const STEPS = [
        {
            label: 'Contact',
            component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />,
        },
    ];

    const [leadStep, setLeadStep] = useState(STEPS);

    const { currentTab: filterStatus, onChangeTab: onChangeFilterStatus, setCurrentTab } = useTabs(SelectTableTab(type));

    // Merge custom-tab hidden_filters on top of the parent's. When the user
    // is on a "custom:<id>" tab, look up that tab record and union its
    // hidden_filters with the practice-level set declared higher up.
    //
    // Two paths produce a custom-tab scope:
    //   1. Inline custom-tab click (legacy: Newest Leads etc.) — sets `filterStatus`
    //      to 'custom:<id>'. We read that here.
    //   2. Wrapper-driven top-placement custom tab (ConsultantAttend / TreatmentStarted)
    //      — the parent page passes `controlledCustomTabId` directly; NewLead's
    //      internal filterStatus is NOT updated by that path, so we have to look
    //      at the prop too. Otherwise per-custom-tab hidden_filters silently
    //      never apply for top-placement custom tabs.
    const activeCustomTab = (() => {
        if (controlledCustomTabId !== undefined && controlledCustomTabId !== null) {
            return customTabs?.find?.((t) => Number(t.id) === Number(controlledCustomTabId)) || null;
        }
        if (typeof filterStatus !== 'string' || !filterStatus.startsWith('custom:')) return null;
        const id = filterStatus.slice('custom:'.length);
        return customTabs?.find?.((t) => String(t.id) === id) || null;
    })();
    const hiddenFilters = activeCustomTab
        ? [...baseHiddenFilters, ...(activeCustomTab.hidden_filters || [])]
        : baseHiddenFilters;

    // The MUI Tabs indicator (the green underline) slides to the tab whose `.value`
    // matches the parent `<Tabs value={...}>` prop. The historical pattern is
    // `notAllType ? contactCount : filterStatus` — fine for categorical sub-tabs
    // (FU1/FU2/FU3+) where contactCount tracks the click, and for status sub-tabs
    // (NEW/CONSULTATION_BOOKED) where filterStatus tracks it. But custom tabs and
    // the synthetic "All" tab use `filterStatus` to track the click on every parent
    // — contactCount is unchanged on click — so the indicator never moves on
    // non-`!notAllType` parents (Newest Leads, Consultation Attended, etc.) when a
    // custom or All tab is active. This helper falls back to `filterStatus` for those
    // two cases, preserving existing behaviour everywhere else.
    // Maps each tab strip's runtime value → its admin slug. Used by `labelCount`
    // to resolve the per-practice label override (set via TableDefaults inline
    // rename). Keyed by `type` so the same NewLead component picks the right
    // map for whatever parent table it's rendering.
    // Each strip value → admin slug. 'All' is the value of the synthetic reset
    // tab injected by the custom-tabs append effect below — must be mapped on
    // every parent so renames to the 'all' slug survive into labelCount().
    // Keep this map in lockstep with the `typeToParent` map further down — if a
    // parent is listed there, it should be listed here too, or label-override
    // renames silently drop on the floor.
    const stripSlugMap = useMemo(() => {
        if (type === 'ConsultantAttend') return { All: 'all' };
        if (type === 'NewLeadTable' || type === 'DashNewLeadTable') return { 0: 'category-new', NHS: 'category-nhs', AWAITING_RESPONSE: 'category-awaiting', 1: 'follow-up-1', 2: 'follow-up-2', 3: 'follow-up-3', All: 'all' };
        if (type === 'NoTaskTable') return { NEW: 'status-new', FOLLOW_UP: 'status-follow-up', CONSULTATION_BOOKED: 'status-consultation-booked', CONSULTATION_ATTENDED: 'status-consultation-attended', FAILED_TO_ATTEND_CONSULTATION: 'status-fta', All: 'all' };
        // Parents with no native category strip — only the synthetic 'All' tab.
        if (type === 'ConsultantBooked' || type === 'AttendedChecklists' || type === 'ConsultantClinCheckAttend') return { All: 'all' };
        return {};
    }, [type]);

    // When the active top-placement custom tab has hidden_sub_tabs, filter the
    // inherited inline strip to only show the slugs the tab allows.
    // When it has checklist_binding.template_ids, render the checklist strip
    // AS WELL AS the normal contacted-count strip (non-destructive composition —
    // task #100 Risk 2). Standalone AttendedChecklists route still shows only the
    // checklist strip (handled by `type === 'AttendedChecklists'` branch which
    // already feeds ATTENDED_CHECKLISTS_TAB_HEAD via setHeading at line 644-645).
    // stripSlugMap must be declared above this useMemo (TDZ guard).
    const checklistStripActive = !!(activeCustomTab?.checklist_binding?.template_ids?.length);

    // V2 checklist empty-state detection (Risk 1, task #98).
    // V1 practices never reach this branch (gated on `tasks-v2`). For V2
    // practices that show zero rows on a checklist surface — either no
    // SystemTaskTemplates configured for this table, or no Tasks auto-created
    // yet — render an EmptyState with guidance instead of a silent blank table.
    // We deliberately don't differentiate templates-vs-tasks because the
    // /tasks/table-columns/ probe requires lead_ids to return columns; with
    // zero rows the probe would always return zero columns and the
    // differentiation collapses. The copy covers both causes.
    const isV2EnabledForPractice = practiceId ? hasFeatureAccess('tasks-v2', practiceId) : false;
    const checklistEmptyStateProbeEnabled = isV2EnabledForPractice && (attendedChecklistsType || checklistStripActive);

    // M-2: when a checklist tab returns 0 rows, the JSX renders EmptyContent instead
    // of NewLeadDataGrid. That means NewLeadDataGrid's internal clearing effect never
    // fires and isChecklistSwitching would stay true — causing a stuck loading gate on
    // the next tab switch. Reset it here once loadingForLead clears with 0 rows.
    useEffect(() => {
        if (!isChecklistSwitching) return;
        if (loadingForLead) return;
        if ((tableData?.length || 0) > 0) return;
        // 0 rows + loading done → EmptyContent path; NewLeadDataGrid is unmounted.
        setIsChecklistSwitching(false);
    }, [isChecklistSwitching, loadingForLead, tableData]);

    const displayedHeadings = useMemo(() => {
        if (!activeCustomTab?.hidden_sub_tabs?.length) return headings;
        const hiddenSlugs = new Set(activeCustomTab.hidden_sub_tabs);
        return headings.filter((h) => {
            const slug = stripSlugMap[String(h.value)];
            return !slug || !hiddenSlugs.has(slug);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [headings, activeCustomTab, stripSlugMap]);
    const stripParentForOverrides = useMemo(() => {
        if (type === 'ConsultantAttend') return 'Consultation Attended Leads';
        if (type === 'NewLeadTable' || type === 'DashNewLeadTable') return 'Newest Leads';
        if (type === 'NoTaskTable') return 'No Task Assigned';
        if (type === 'ConsultantBooked') return 'Consultation Booked Leads';
        if (type === 'AttendedChecklists') return 'Attended Checklists';
        if (type === 'ConsultantClinCheckAttend') return 'Consultation ClinCheck Leads';
        if (type === 'treatmentStarted') return 'Treatment Started Leads';
        return null;
    }, [type]);

    // Memoised because `labelCount` (called per-tab in the strip render) reads
    // activeStripValue to compute `isActive` on every cell — a string identity
    // change cascades to all tab badges. Inputs are all primitives, so the memo
    // only invalidates when the value actually changes (not on every render).
    const activeStripValue = useMemo(() => {
        const isCustomOrAll = typeof filterStatus === 'string'
            && (filterStatus === 'All' || filterStatus.startsWith('custom:'));
        if (isCustomOrAll) return filterStatus;
        return notAllType ? contactCount : filterStatus;
    }, [filterStatus, notAllType, contactCount]);

    useEffect(() => {
        dispatch(selectLeads({ leadId: [], type: '', loading: false }));
    }, [filterStatus]);

    const dataFiltered = applySortFilter({
        tableData,
        filterStatus,
    });

    const isNotFound =
        (!dataFiltered.length && (!!filterStatus || filterStatus === 0 ? true : filterStatus)) || !dataFiltered;
    const bookedWithLabel = getUserList()
        .filter((el) => bookedWithData.includes(el.user.id))
        ?.map((ele) => `${ele?.user?.salutation || ''} ${ele?.user?.first_name || ''} ${ele?.user?.last_name || ''}`);
    const consultationBookedWithLabel = getUserList()
        .filter((el) => consultationBookedWithData.includes(el.user.id))
        ?.map((ele) => `${ele?.user?.salutation || ''} ${ele?.user?.first_name || ''} ${ele?.user?.last_name || ''}`);

    const defaultValues = {
        multiSelect: treatmentData || [],
        referral: referral || '',
        practices: practices || '',
        category,
        bookedWith: bookedWithData ? bookedWithLabel : [] || [],
        consultationBookedWith: consultationBookedWithData ? consultationBookedWithLabel : [] || [],
        multiSelectAssignee: assigneeData || [],
        archiveReason: archiveReason || '',
    };

    const methods = useForm({
        defaultValues,
    });

    const { setValue, handleSubmit } = methods;

    const { toggle: openContacts, onClose: onCloseContacts } = useToggle();

    const { toggle: leadDetailModal, onOpen: onLeadDetail, onClose: onCloseLeadDetail } = useToggle();

    const { toggle: openFollowLead, onOpen: onOpenFollowLead, onClose: onCloseFollowLead } = useToggle();

    const {
        toggle: openConsultationAttend,
        onOpen: onOpenConsultationAttend,
        onClose: onCloseConsultationAttend,
    } = useConsultationAttendToggle();

    const {
        toggle: openRecordAttend,
        onOpen: onOpenRecordAttend,
        onClose: onCloseRecordAttend,
    } = useRecordAttendToggle();

    const { toggle: openAttendedNote, onOpen: onOpenAttendedNote, onClose: onCloseAttendedNote } = useToggle();

    const {
        toggle: openUnRecordAttend,
        onOpen: onOpenUnRecordAttend,
        onClose: onCloseUnRecordAttend,
    } = useUnRecordAttendToggle();

    const {
        toggle: openRestoreArchived,
        onOpen: onOpenRestoreArchived,
        onClose: onCloseRestoreArchived,
    } = useRestoreArchived();

    const { toggle: openArchiveLead, onOpen: onOpenArchiveLead, onClose: onCloseArchiveLead } = useArchivedToggle();

    const { toggle: openAddTreatment, onOpen: onOpenAddTreatment, onClose: onCloseAddTreatment } = useAddTreatment();

    const { toggle: OpenReSchedule, onOpen: onOpenReSchedule, onClose: onCloseReSchedule } = useToggle();

    const { toggle: toggleDuplicatePopup, onOpen: openDuplicatePopup, onClose: closeDuplicatePopup } = useToggle();
    const {
        toggle: toggleUnMarkAsDuplicate,
        onOpen: openUnMarkAsDuplicate,
        onClose: closeUnMarkAsDuplicate,
    } = useToggle();

    const {
        toggle: toggleMarkAsSpam,
        onOpen: openMarkAsSpamDialog,
        onClose: closeMarkAsSpamDialog,
    } = useToggle();

    const {
        toggle: openContactLead,
        onOpen: onOpenContactLead,
        onClose: onCloseContactLead,
    } = useToggle();

    const {
        toggle: openAppointment,
        onOpen: onOpenAppointment,
        onClose: onCloseAppointment
    } = useAppointmentToggle();

    const handleReScheduleClose = () => {
        onCloseReSchedule();
        handleClose('finish');
    };

    const handleAppointmentClose = () => {
        onCloseAppointment();
        handleClose('finish');
    };

    const editDetailHandler = () => onLeadDetail();

    const closeEditDetails = () => {
        handleReloadAPI('finish');
        onCloseLeadDetail();
    };

    useEffect(() => {
        if (practiceUser) {
            const getUserList = () =>
                practiceUser?.results?.filter((el) => el.user && el.user.first_name && !el.user.is_superuser);
            const data = _.orderBy(
                getUserList(),
                [(o) => (o.user?.first_name).toLowerCase(), (o) => (o.user?.last_name).toLowerCase()],
                ['asc', 'asc']
            );
            setUserList(data);
        }
    }, [practiceUser]);

    useEffect(() => {
        if (filterStatus && headings) {
            const filteredData = commonType
                ? treatmentStartedType
                    ? headings.filter((el) => Number(el.id) === Number(filterStatus))[0]?.name
                    : headings.filter((el) => el.value === filterStatus)[0]?.label
                : '';
            setFilters({
                status: filteredData,
                treatment: treatmentValue,
                tags: searchFilterTags,
                referral: referralData?.filter((e) => e.value === referral)[0]?.label || '',
                startDate,
                practices,
                endDate,
                assignTo: bookedWith,
                consultationBookedWith,
                statusLabel:
                    (consultantBookedType && 'Appointment method') || (treatmentStartedType && 'Treatment category') || '',
                depositPaidFilter: depositPendingStatus,
                assigneeSelectedForFilter,
                archiveReason: archiveReasonData?.filter((e) => e.value === archiveReason)[0]?.label || '',
            });
        }
    }, [
        filterStatus,
        headings,
        treatmentValue,
        searchFilterTags,
        referral,
        practices,
        startDate,
        endDate,
        bookedWith,
        consultationBookedWith,
        userList,
        depositPendingStatus,
        assigneeSelectedForFilter,
        archiveReason,
    ]);

    const handleStartedTablePayload = (payloadData) => {
        if (!treatmentStartedType) return;
        payloadData.consultationBookedWith = consultationBookedWithData?.toString();
        payloadData.apptType = apptType;
    };

    useEffect(() => {
        const practiceMap = {};
        practiceTreatment?.results?.forEach?.(val => {
            practiceMap[val?.id] = val?.name
        })
        setPracticeListMap(practiceMap);
        setRowsPerPage(perPage);
        setPage(pageNumber / perPage);
        setPaginationModel({ pageSize: perPage, page: pageNumber / perPage });
        // On checklist-bound tabs, treatment and contactedCount must not leak into
        // API calls — the tab's filter scope comes from customTabId / checklistState.
        // This useEffect fires when practiceTreatment loads (after a tab switch), at
        // which point treatmentData may still hold a prior-tab value from Redux.
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: checklistStateValue ? undefined : treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: checklistStateValue ? 'All' : contactCount,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false
        };
        handleStartedTablePayload(payloadData);
        if (isReportData) {
            updateLeadPage(payloadData);
            if (practiceId) {
                dispatch(getPracticeItem(practiceId));
            }
        }
        if (practiceId) dispatch(loadCustomTabs(practiceId));
        dispatch(startLoadingData(true));
        dispatch(updateDashNewLead({ results: [] }));
        if (practiceId && practiceTreatment?.results?.length > 0) {
            const data = {
                limit: 50,
                offset: 0,
                category: categoryName !== 'All' && categoryName,
            };
            if (isReportData && type !== 'treatmentStartedWithInvisalign' && selectedTab !== 'invisalignAdditional') {
                dispatch(getPracticeTreatmentList(practiceId, data));
            }
        }
        if (noConsultantBookedType && notArchType && results) {
            dispatch(updateCounter([]));
        }

        if (tableData && practiceId && reloadCounter && practiceTreatment?.results?.length > 0) {
            reloadCounter(payloadData);
        }

    }, [practiceId, practiceTreatment, activePracticeIdsKey]);

    useEffect(() => {
        if (searchQuery !== null) {
            if (debouncedValue) {
                dispatch(updateCounter([]));
                const payloadData = {
                    limit: perPage,
                    offset: pageNumber,
                    filterStatus: notAllType ? contactCount : filterStatus,
                    order: tableOrder,
                    orderId: tableOrderBy,
                    searchQuery: searchValue,
                    treatment: treatmentData?.toString(),
                    startDate,
                    endDate,
                    contactedCount: contactCount,
                    tags: searchTags,
                    referral,
                    practices,
                    depositPendingStatus,
                    category,
                    bookedWith: bookedWithData?.toString(),
                    assigneeIds: assigneeData?.toString(),
                    archiveReason,
                    noTreatment: false
                };
                handleStartedTablePayload(payloadData);
                updateLeadPage(payloadData);
                if (tableData && reloadCounter) {
                    reloadCounter(payloadData);
                }
                setCurrentTab(notAllType ? contactCount : filterStatus);
            } else {
                dispatch(updateCounter([]));
                const payloadData = {
                    limit: perPage,
                    offset: pageNumber,
                    filterStatus: tableStatus,
                    order: tableOrder,
                    orderId: tableOrderBy,
                    searchQuery: searchValue,
                    treatment: treatmentData?.toString(),
                    startDate,
                    endDate,
                    contactedCount: contactCount,
                    tags: searchTags,
                    referral,
                    practices,
                    depositPendingStatus,
                    category,
                    bookedWith: bookedWithData?.toString(),
                    assigneeIds: assigneeData?.toString(),
                    archiveReason,
                    noTreatment: false
                };
                handleStartedTablePayload(payloadData);
                updateLeadPage(payloadData);
                if (tableData && practiceId && reloadCounter) {
                    reloadCounter(payloadData);
                }
            }
        }
    }, [debouncedValue]);

    useEffect(() => {
        if (selectedRow && followUpLead === 'contactLead' && shouldCallReminder?.current) {
            dispatch(getActivities(practiceId, selectedRow?.lead_id, 10, 0));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 50, 0, 'leadNotes', selectedRow?.lead_id, '', '', '', 'counter'));
        }
    }, [selectedRow, practiceId]);

    useEffect(() => {
        leadData.map((item) => {
            const latestData = handleLatestData(item, type, rowStatus);
            const latestItem = type === 'treatmentStartedWithInvisalign' ? {
                ...item,
                lead_treatments: item?.lead_treatments?.filter(treatment =>
                    treatment.treatment === 'Invisalign' && treatment.status === 'TREATMENT_STARTED'
                )
            } : item;
            rowData.push(handleTableData(latestItem, latestData, practiceListMap));
            return item;
        });
        if (rowData) {
            setTableData(rowData);
        }
    }, [leadData, page]);

    const handleSetTableData = (item) => {
        setTableData((state) => state.map((ele) => {
            if (ele.lead_id === item.id) {
                const latestData = handleLatestData(item, type, rowStatus);
                const latestItem = type === 'treatmentStartedWithInvisalign' ? {
                    ...item,
                    lead_treatments: item?.lead_treatments?.filter(treatment =>
                        treatment.treatment === 'Invisalign' && treatment.status === 'TREATMENT_STARTED'
                    )
                } : item;
                return handleTableData(latestItem, latestData, practiceListMap);
            }
            return ele;
        }));
    };

    const handleArchivedClose = () => {
        onCloseArchiveLead();
        if (type === 'NewLeadTable' && setUpdateList) {
            setUpdateList(true);
        }
        if (openFollowLead) {
            dispatch(updateFollowUpLead('contactLead'));
        } else {
            dispatch(getLeadReminderData(practiceId, 'dashboard', limit, offset, filter, '', assignUser));
        }
    };

    useEffect(() => {
        if (message) {
            enqueueSnackbar(message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            setTimeout(() => {
                dispatch(clearMessage());
            }, 3000);
        }
        if (error) {
            enqueueSnackbar(error?.detail || 'something went wrong', {
                variant: 'error',
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
            });
            setTimeout(() => {
                dispatch(clearMessage());
            }, 3000);
        }
    }, [message, error]);

    useEffect(() => {
        if (markAsComplete) {
            switch (followUpLead) {
                case 'contactLead':
                    dispatch(updateLeadDetail(isAppointmentBooked, handleClose));
                    break;
                case 'consultationAttended':
                    dispatch(ConsultationAttended(handleClose));
                    break;
                case 'recordAttended':
                    dispatch(RecordAttended(handleClose));
                    break;
                case 'recordUnAttended':
                    dispatch(recordUnAttended(handleClose));
                    break;
                case 'archivedLead':
                    dispatch(ArchivedLeadDashBoard(handleClose));
                    break;
                case 'restoreArchived':
                    dispatch(restoreArchived(handleClose));
                    break;
                case 'StartTreatmentConfirmation':
                    dispatch(ConsultationAttended(handleClose));
                    break;
                default:
                    break;
            }
        }
    }, [markAsComplete, followUpLead]);

    const handlePaginationChange = (newPageData) => {

        const { page, pageSize } = newPageData;
        const payloadData = {
            limit: pageSize,
            offset: pageSize * page,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            bookedWidgetFilter
        };
        handleStartedTablePayload(payloadData);
        updateLeadPage(payloadData);
        onChangePage('', page);
        UpdateTableData(type, { perPage: pageSize, pageNumber: pageSize * page });
    };

    const handleChangePerPage = (event) => {

        const payloadData = {
            limit: event.target.value,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            bookedWidgetFilter
        };
        handleStartedTablePayload(payloadData);
        updateLeadPage(payloadData);
        onChangeRowsPerPage(event);
        UpdateTableData(type, { perPage: event.target.value });
    };

    const handleChangeStatus = (event, newValue) => {
        setPage(0);
        setRowsPerPage(10);
        setForceUpdate(prv => !prv);
        onChangeFilterStatus(event, newValue);
        setPaginationModel({ pageSize: 10, page: 0 });
        // Custom sub-tab detection happens before the treatment-started category
        // shortcut — custom tabs use a synthetic "custom:<id>" value that must
        // not be misinterpreted as a category id.
        const isCustomTab = typeof newValue === 'string' && newValue.startsWith('custom:');
        const customTabId = isCustomTab ? newValue.slice('custom:'.length) : undefined;
        // Universal "All" reset: clears any active custom tab + category filter +
        // contact-count, surfaces every lead the parent is responsible for. Behavior
        // per parent:
        //   - ConsultantAttend / NewLeadTable / DashNewLeadTable: parent wrapper
        //     hardcodes `filterStatus` (CONSULTATION_ATTENDED / NEW), so the API
        //     query still scopes to the parent status — All shows ALL leads in
        //     that status, regardless of category or custom tab.
        //   - NoTaskTable / Dashboard: no wrapper override, so filterStatus is
        //     updated to 'All' here too and coreThunks treats that as "no status
        //     filter" — All means leads across every status (per the existing
        //     `filterStatus === 'All'` sentinel pattern in coreThunks.js:160).
        //   - treatmentStarted: routed through handleCategory below, which
        //     follows the same reset semantics as the dynamic All category.
        //
        // Value is 'All' (capital) to match the existing contactedCount sentinel
        // already special-cased throughout coreThunks.js. Slug is 'all' (lowercase) —
        // that's the admin-hide key in TABS_PER_TABLE and is intentionally separate
        // from the runtime tab.value.
        if (newValue === 'All') {
            if (treatmentStartedType) {
                handleCategory({ target: { innerText: 'All' } }, null);
                return;
            }
            const resetPayload = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder || 'desc',
                orderId: tableOrderBy || 'created_at',
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: 'All',
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category: '0',
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
                customTabId: undefined,
            };
            updateLeadPage(resetPayload);
            if (tableData && practiceId && reloadCounter) {
                reloadCounter(resetPayload);
            }
            UpdateTableData(type, { count: 'All', category: '0', categoryName: '', perPage: 10, pageNumber: 0 });
            return;
        }
        if (treatmentStartedType && !isCustomTab) {
            handleCategory(event, newValue);
            return;
        }
        // When entering a custom sub-tab on Treatment Started, clear any
        // residual category state from prior category-tab clicks — the
        // custom-tab branch in coreThunks supplies its own treatment scope
        // and shouldn't be filtered by category as well.
        if (treatmentStartedType && isCustomTab) {
            UpdateTableData(type, { category: '0', categoryName: '', treatment: [] });
        }
        // AttendedChecklists standalone route sub-tabs use checklist_state
        // (in_progress | completed), not contactedCount. Keep filterStatus as
        // CONSULTATION_ATTENDED. Custom tabs with checklist_binding now render
        // BOTH strips (task #100 Risk 2); their checklist strip uses
        // handleChangeChecklistState instead of this handler.
        if (type === 'AttendedChecklists') {
            const checklistPayload = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: 'desc',
                orderId: 'created_at',
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: 'All',
                checklistState: newValue,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
            };
            updateLeadPage(checklistPayload);
            if (tableData && practiceId && reloadCounter) {
                reloadCounter(checklistPayload);
            }
            UpdateTableData(type, { count: newValue, checklistState: newValue, perPage: 10, pageNumber: 0 });
            return;
        }
        // Custom sub-tab selected: keep the parent table's filterStatus (don't
        // overwrite with the synthetic "custom:<id>" value), and pass customTabId
        // so coreThunks adds the treatment-scope and predicate filters.
        // Task #100 Risk 2: preserve checklistState when clicking the
        // contacted-count strip on a checklist-bound custom tab so the two
        // strips compose (e.g. FU1 click keeps the active In Progress filter).
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus: isCustomTab ? filterStatus : newValue,
            order: 'desc',
            orderId: 'created_at',
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: isCustomTab ? contactCount : (newValue === 'AWAITING_RESPONSE' ? '' : newValue),
            checklistState: checklistStripActive ? (checklistStateValue || undefined) : undefined,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category: isCustomTab ? '0' : category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            customTabId,
        };
        updateLeadPage(payloadData);
        if (isNoTaskLeadsTable) {
            UpdateTableData(type, { count: newValue, perPage: 10, pageNumber: 0 });
        } else {
            UpdateTableData(type, { count: newValue, perPage: 10, pageNumber: 0 });
        }
    };

    // Task #100 Risk 2 — Composable second strip handler.
    // Fires when the user clicks the [In Progress | Follow-Up Complete] strip
    // that renders BELOW the normal contacted-count strip on a custom tab with
    // checklist_binding active. Only mutates checklistState — leaves contactCount
    // (first-strip selection) untouched so the two filters compose: e.g.
    // "Follow up 1 + In Progress" hits contacted_count_for_status=1,exact,CONSULTATION_ATTENDED
    // AND checklist_state=in_progress on the same query.
    const handleChangeChecklistState = (event, newValue) => {
        // Bug 1 fix: raise the busy gate so the DataGrid stays in loading state
        // until BOTH the new rows AND their checklist cells have resolved.
        // The gate is cleared via onChecklistSwitchingDone passed to NewLeadDataGrid.
        setIsChecklistSwitching(true);
        // Bug 2c fix: write the new state to the URL so browser-back restores it.
        // ConsultantAttend passes this callback; other wrappers pass null (no-op).
        onChecklistStateChange?.(newValue);
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        const checklistPayload = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder || 'desc',
            orderId: tableOrderBy || 'created_at',
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount, // preserve first-strip selection
            checklistState: newValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            customTabId: activeCustomTab?.id ?? undefined,
        };
        updateLeadPage(checklistPayload);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(checklistPayload);
        }
        UpdateTableData(type, { checklistState: newValue, perPage: 10, pageNumber: 0 });
    };

    const sortingApiCall = (id, defaultOrder) => {
        onChangePage(id, 0);
        const payloadData = {
            limit: rowsPerPage,
            offset: 0,
            filterStatus,
            order: defaultOrder,
            orderId: id,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            bookedWidgetFilter
        };

        handleStartedTablePayload(payloadData);
        updateLeadPage(payloadData);
    };

    useEffect(() => {
        if (contactLead) {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />,
                },
            ];
            setLeadStep(STEPS);
        } else {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <Activities activityList={activityList?.results} notAllow />,
                },
            ];
            setLeadStep(STEPS);
        }
    }, [contactLead]);

    useEffect(() => {
        if (BookingAttendance) {
            const steps = [...STEPS];
            const row = rowLead.current;
            if (isAppointmentBooked === 'Booking Details' && pmsEnabledGlobal && !dentallyEnabledGlobal) {
                // PMS path: 2 steps — Availability → Confirm Booking
                steps.push({
                    label: 'Select Appointment',
                    component: (
                        <PmsAvailabilityWizardStep
                            ref={inputRef}
                            handleNext={onSubmit}
                            practiceId={practiceId}
                            pmsSlot={pmsSlot}
                            onSlotSelected={setPmsSlot}
                            selectedPractitioner={pmsPractitioner}
                            onPractitionerSelected={setPmsPractitioner}
                            selectedDate={pmsDate}
                            onDateSelected={setPmsDate}
                        />
                    ),
                });
                steps.push({
                    label: 'Confirm Booking',
                    ...pmsConfirmStepState,
                    component: (
                        <PmsBookingConfirmStep
                            ref={inputRef}
                            pmsSlot={pmsSlot}
                            practiceId={practiceId}
                            existingLead={followLead ? {
                                id: followLead.id,
                                first_name: followLead.first_name,
                                last_name: followLead.last_name,
                                lead_contact: {
                                    phone: followLead.lead_contact?.phone,
                                    email: followLead.lead_contact?.email,
                                },
                            } : null}
                            existingTreatmentId={currentTreatmentDataGlobal?.treatmentData?.id ? Number(currentTreatmentDataGlobal.treatmentData.id) : null}
                            onClose={(success) => {
                                if (success) handleClose('finish');
                            }}
                            onStepStateChange={setPmsConfirmStepState}
                        />
                    ),
                });
            } else if (isAppointmentBooked === 'Booking Details' && dentallyEnabledGlobal && useDentallyFlow) {
                // Dentally path: 2 steps — Treatment & Availability → Confirm Booking
                steps.push({
                    label: 'Treatment & Availability',
                    component: (
                        <Box>
                            <BookingModeToggle useDentally onChange={handleToggleBookingMode} />
                            <DentallyTreatmentAvailabilityWizardStep
                                ref={inputRef}
                                handleNext={onSubmit}
                                practiceId={practiceId}
                                dentallySlot={dentallySlot}
                                onSlotSelected={setDentallySlot}
                                selectedDentallyTreatment={selectedDentallyTreatment}
                                onTreatmentSelected={(treatment) => {
                                    setSelectedDentallyTreatment(treatment);
                                }}
                                assignees={dentallyAssignees}
                                onAssigneesChanged={setDentallyAssignees}
                            />
                        </Box>
                    ),
                });
                steps.push({
                    label: 'Confirm Booking',
                    ...followUpConfirmStepState,
                    component: (
                        <DentallyFollowUpConfirmWizardStep
                            ref={inputRef}
                            selectedSlot={dentallySlot}
                            practiceId={practiceId}
                            existingLead={followLead ? {
                                id: followLead.id,
                                first_name: followLead.first_name,
                                last_name: followLead.last_name,
                                lead_contact: {
                                    phone: followLead.lead_contact?.phone,
                                    email: followLead.lead_contact?.email,
                                },
                                dob: followLead.dob,
                            } : null}
                            existingTreatmentId={currentTreatmentDataGlobal?.treatmentData?.id ? Number(currentTreatmentDataGlobal.treatmentData.id) : null}
                            onClose={(success) => {
                                if (success) handleClose('finish');
                            }}
                            onStepStateChange={setFollowUpConfirmStepState}
                        />
                    ),
                });
            } else if (isAppointmentBooked === 'Booking Details') {
                // Standard CRM-only path (Dentally disabled or user toggled to CRM-only)
                steps.push({
                    label: isAppointmentBooked,
                    component: (
                        <Box>
                            {dentallyEnabledGlobal && <BookingModeToggle useDentally={false} onChange={handleToggleBookingMode} />}
                            <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview hideDentally />
                        </Box>
                    ),
                });
            } else if (isAppointmentBooked === 'WhatsApp Follow Up') {
                steps.push({
                    label: 'Follow Up',
                    component: <WhatsAppFollowUpStep ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />,
                });
            } else if (isAppointmentBooked === 'WhatsApp Close') {
                steps.push({
                    label: 'Close',
                    component: <WhatsAppCloseStep ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />,
                });
            } else {
                // Unable to contact or appointment page
                steps.push({
                    label: isAppointmentBooked,
                    component:
                        isAppointmentBooked === 'Unable to contact' ? (
                            <UnableToContact
                                ref={inputRef}
                                handleNext={onSubmit}
                                openArchivePopup={() => onOpenArchiveLead(row?.lead_id)}
                                isOverview
                                completeFlow={handleClose}
                            />
                        ) : (
                            <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                        ),
                });
            }
            setLeadStep(steps);
        } else {
            setLeadStep(STEPS);
        }
    }, [BookingAttendance, dentallySlot, selectedDentallyTreatment, dentallyAssignees, followLead, followUpConfirmStepState, useDentallyFlow, pmsSlot, pmsPractitioner, pmsDate, pmsConfirmStepState]);

    useEffect(() => {
        if (attendance && isAppointmentBooked !== 'Appointment Not Booked') {
            const steps = [...STEPS];
            const row = rowLead.current;
            if (attendance === 'attendance') {
                steps.push({
                    label: isAppointmentBooked,
                    component:
                        isAppointmentBooked === 'Booking Details' ? (
                            <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        ) : isAppointmentBooked === 'Unable to contact' ? (
                            <UnableToContact
                                ref={inputRef}
                                handleNext={onSubmit}
                                openArchivePopup={() => onOpenArchiveLead(row?.lead_id)}
                                isOverview
                                completeFlow={handleClose}
                            />
                        ) : (
                            <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                        ),
                });
                steps.push({
                    label: 'Appointment Outcome',
                    component: <AttendedAppointment ref={inputRef} handleNext={onSubmit} isOverview />,
                });
            } else {
                steps.push({
                    label: isAppointmentBooked,
                    component:
                        isAppointmentBooked === 'Booking Details' ? (
                            <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        ) : isAppointmentBooked === 'Unable to contact' ? (
                            <UnableToContact
                                ref={inputRef}
                                handleNext={onSubmit}
                                openArchivePopup={() => onOpenArchiveLead(row?.lead_id)}
                                isOverview
                                completeFlow={handleClose}
                            />
                        ) : (
                            <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                        ),
                });
                steps.push({
                    label: 'Personal Details',
                    component: <PersonalDetails ref={inputRef} handleNext={onSubmit} />,
                });
                steps.push({
                    label: 'Payment options',
                    component: <PaymentOption ref={inputRef} handleNext={onSubmit} />,
                });
                if (dentallyEnabledGlobal && isDentallyBooking) {
                    steps.push({
                        label: 'Dentally Confirmation',
                        component: <DentallyPaymentConfirmation ref={inputRef} handleNext={onSubmit} />,
                    });
                }
                steps.push({
                    label: 'Message review & reminders',
                    component: <MessageAndReminder ref={inputRef} handleNext={onSubmit} type={'FollowUp'} row={selectedRow} />,
                });
            }
            setLeadStep(steps);
        } else {
            setLeadStep(STEPS);
        }
    }, [attendance, isDentallyBooking]);

    useEffect(() => {
        if (!followUpLead) {

            handleClose();
            dispatch(updateSteps(null));
        }
    }, [followUpLead]);

    const handleCompletedToStartAPI = () => {
        const row = rowLead.current;
        const data = {
            id: row.treatment_id,
            practiceId,
            leadId: row?.lead_id,
            handleClose
        };
        dispatch(completedToStart(data));
    };

    const onSelectedRow = async (row, typed, isFlowButtonClicked, event) => {
        if (showPracticeColumn && typed !== "changePractice") {
            enqueueSnackbar(`Switching Practice to ${capitalizeFirstLetter(row?.practiceName)}`, {
                variant: 'warning',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
            dispatch(updatePracticeIdToChange(row?.practiceId));
            await new Promise(resolve => setTimeout(resolve, 2000));
            enqueueSnackbar(`Practice switched to ${capitalizeFirstLetter(row?.practiceName)}`, {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
        }
        localStorageRemoveItem('localTreatmentData');
        setSelectedRow(row);
        if (isFlowButtonClicked) {
            shouldCallReminder.current = false;
        } else {
            shouldCallReminder.current = true;
        }
        const latestData = handleLatestData({ lead_treatments: row?.treatmentData || [] }, type, rowStatus);
        setDepositStatus(!latestData?.[0]?.is_treatment_fee_pending);
        dispatch(updateFollowUpLead(typed));
        switch (typed) {
            case 'consultationAttended':
                onOpenConsultationAttend();
                break;
            case 'deleteTreatmentPayment':
                paymentDeleteToggle.onOpen();
                onCloseDepositPaymentPopup();
                setAnchorDepositPayment(null);
                break;
            case 'recordAttended':
                onOpenRecordAttend();
                break;
            case 'recordUnAttended':
                onOpenUnRecordAttend();
                break;
            case 'restoreArchived':
                onOpenRestoreArchived(row.id);
                break;
            case 'archivedLead':
                onOpenArchiveLead(row.id);
                break;
            case 'backToAttended':
                onOpenAttendedNote(row.id);
                break;
            case 'addTreatment':
                onOpenAddTreatment('openAddTreatment');
                setAnchorEditTreatment(event.currentTarget);
                break;
            case 'editTreatment':
                onopenTreatmentEditPopup();
                setAnchorEditTreatment(event.currentTarget);
                break;
            case 'changePractice':
                onopenPracticePopup();
                setAnchoranchorPractice(event.currentTarget);
                break;
            case 'deposit_payment':
                onOpenDepositPaymentPopup();
                setAnchorDepositPayment(event.currentTarget);
                break;
            case 'markAsDuplicate':
                openDuplicatePopup();
                rowLead.current = row;
                break;
            case 'unMarkAsDuplicate':
                openUnMarkAsDuplicate();
                rowLead.current = row;
                break;
            case 'markAsSpam':
                openMarkAsSpamDialog();
                rowLead.current = row;
                break;
            case 'TreatmentConfirmation':
                setConfirmation(true);
                rowLead.current = row;
                break;
            case 'StartTreatmentConfirmation':
                setStartConfirmation(true);
                rowLead.current = row;
                break;
            case 'CompletedToStartTreatment':
                rowLead.current = row;
                handleCompletedToStartAPI();
                break;
            case 'EditAppointment':
                onOpenReSchedule(row);
                setAppoinmentSelectData(row);
                break;
            case 'AddAppointment':
                onOpenAppointment();
                break;
            case 'ClinCheckStatusOpen':
                openClinCheckStatusPopup(row, event);
                break;
            case 'contactLead': {
                const { openWhatsapp } = event ?? {};
                setContactLeadDefaultTab(openWhatsapp ? 'whatsapp' : 'overview');
                onOpenContactLead(row);
                break;
            }
            default:
                onOpenFollowLead();
                break;
        }
    };

    useEffect(() => {
        if (leadData.length > 0) {
            dispatch(startArchivedLoading(false));
        }
    }, [leadData]);

    useEffect(() => {
        if (displayForCategorySummary && leadCategoryType !== filterStatus) {
            handleChangeStatus("", leadCategoryType);
        }
    }, [filterStatus]);

    const completeTreatmentAPI = () => {
        const row = rowLead.current;
        const data = {
            treatment: row.treatment_name || '',
            custom_price: row.price,
        };
        dispatch(setLoader(true));
        dispatch(CompleteTreatment(data, row.lead_id, row.treatment_id, practiceId, handleReloadAPI));
    };

    const startTreatmentAPI = () => {
        const row = rowLead.current;
        const data = {
            treatment: row.treatment_name || '',
            custom_price: row.price,
            lead: row.lead_id,
            id: row.treatment_id,
        };
        dispatch(setLoader(true));
        dispatch(StartingTreatment(data, practiceId, handleClose, 'startingTreatmentFinish'));
    };

    const handleMarkAsDuplicateAPI = () => {
        const row = rowLead.current;
        dispatch(markAsDuplicate({ practiceId, leadId: row?.lead_id, handleClose }));
    };
    const handleUnMarkAsDuplicateAPI = () => {
        const row = rowLead.current;
        dispatch(unMarkAsDuplicate({ practiceId, leadId: row?.lead_id, handleClose }));
    };

    const handleMarkAsSpamAPI = () => {
        const row = rowLead.current;
        closeMarkAsSpamDialog();
        dispatch(markAsSpam({ practiceId, leadId: row?.lead_id, handleClose }));
    };

    const handleReloadAPI = (value) => {
        if (value === 'finish') {
            dispatch(updateCounter([]));
            const reloadPayLoad = {
                limit: perPage,
                offset: pageNumber,
                filterStatus: notAllType ? contactCount : filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
            };
            updateLeadPage(reloadPayLoad);
            if (tableData && practiceId && reloadCounter) {
                reloadCounter(reloadPayLoad);
            }
            dispatch(getLeadReminderData(practiceId, 'dashboard', limit, offset, filter, '', assignUser));
            setConfirmation(false);
            dispatch(setLoader(false));
        }
    };

    const handleSearch = (data) => {
        let search = data.trim();
        if (data.includes('+')) {
            search = `+44${parseInt(data.split('+44')[1], 10)}`;
        }
        if (Number(data) && !data.includes('+')) {
            search = `${parseInt(data, 10)}`;
        }
        setSearchQuery(data);
        setSearch(data);
        UpdateTableData(type, { search: encodeURIComponent(search), perPage: 10, pageNumber: 0 });
        syncToUrl(buildUrlFilterState({ search: data }));
    };

    const onResetFilter = () => {
        const { setStartDate, setEndDate } = picker;
        if (dashBoardDateProps?.dateChange) {
            dashBoardDateProps.dateChange([null, null]);
        }
        if (shouldRunEffect) {
            shouldRunEffect.current = false;
        }
        dispatch(updateCounter([]));
        dispatch(updateSuperAdmin({
            practices: []
        }));
        setSearch('');
        setSearchQuery(null);
        setValue('practices', '');
        setValue('multiSelect', []);
        setValue('referral', '');
        setValue('archiveReason', '');
        setValue('category', '');
        setValue('bookedWith', []);
        setValue('consultationBookedWith', []);
        setValue('multiSelectAssignee', [])
        setDepositPendingFilter('');
        setStartDate(null);
        setEndDate(null);
        setDate([null, null]);
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order,
            orderId: orderByValue,
            searchQuery: null,
            treatment: null,
            startDate: null,
            endDate: null,
            contactedCount: contactCount,
            tags: '',
            referral: '',
            practices: '',
            depositPendingStatus: '',
            category,
            bookedWith: '',
            assigneeIds: '',
            archiveReason: ''
        };
        const updatedTableData = {
            search: '',
            date: [],
            treatment: [],
            perPage: 10,
            pageNumber: 0,
            tag: [],
            filterTags: [],
            referral: '',
            practices: '',
            bookedWith: [],
            depositPendingStatus: '',
            assignee: [],
            archiveReason: ''
        };
        if (treatmentStartedType) {
            payloadData.apptType = '';
            payloadData.consultationBookedWith = '';
            updatedTableData.apptType = '';
            updatedTableData.consultationBookedWith = [];
        }
        updateLeadPage(payloadData);
        if (tableData && practiceId && reloadCounter) {
            if (dashType) {
                reloadCounter({ ...payloadData, isComeFromDateChange: true });
            } else {
                reloadCounter(payloadData);
            }
        }
        UpdateTableData(type, updatedTableData);
        setPaginationModel({ pageSize: 10, page: 0 });
        syncToUrl({});
    };

    const handleTreatment = (e, value) => {
        if (value) {
            const ids = [];
            value.map((data) => ids.push(data.id));
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: ids?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason
            };
            handleStartedTablePayload(payloadData);
            updateLeadPage(payloadData);
            setPage(0);
            setRowsPerPage(10);
            setPaginationModel({ pageSize: 10, page: 0 });
            setValue('multiSelect', ids);
            if (tableData && practiceId && reloadCounter) {
                reloadCounter(payloadData);
            }
            UpdateTableData(type, { treatment: value, perPage: 10, pageNumber: 0 });
            syncToUrl(buildUrlFilterState({ treatment: value }));
        } else {
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: '',
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason
            };
            handleStartedTablePayload(payloadData);
            updateLeadPage(payloadData);
            if (tableData && practiceId && reloadCounter) {
                reloadCounter(payloadData);
            }
            setPage(0);
            setRowsPerPage(10);
            setPaginationModel({ pageSize: 10, page: 0 });
            setValue('multiSelect', []);
            UpdateTableData(type, { treatment: [], perPage: 10, pageNumber: 0 });
            syncToUrl(buildUrlFilterState({ treatment: [] }));
        }
    };

    const handleAssigneeFilter = (e, value) => {

        if (value) {
            const ids = [];
            value.map((data) => ids.push(data.id));
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: ids?.toString(),
                archiveReason,
                noTreatment: false
            };
            updateLeadPage(payloadData);
            setPage(0);
            setRowsPerPage(10);
            setPaginationModel({ pageSize: 10, page: 0 });
            setValue('multiSelectAssignee', ids);

            if (tableData && practiceId && reloadCounter) {
                reloadCounter(payloadData);
            }
            UpdateTableData(type, { assignee: value, perPage: 10, pageNumber: 0 });
            syncToUrl(buildUrlFilterState({ assignee: value }));
        } else {
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: '',
                archiveReason,
                noTreatment: false
            };
            updateLeadPage(payloadData);
            if (tableData && practiceId && reloadCounter) {
                reloadCounter(payloadData);
            }
            setPage(0);
            setRowsPerPage(10);
            setPaginationModel({ pageSize: 10, page: 0 });
            setValue('multiSelectAssignee', []);
            UpdateTableData(type, { assignee: [], perPage: 10, pageNumber: 0 });
            syncToUrl(buildUrlFilterState({ assignee: [] }));
        }
    }

    const CONTACTED_COUNT_OPTIONS = [
        { value: '', label: 'All' },
        { value: '0', label: 'New (0)' },
        { value: '1', label: 'Follow up 1' },
        { value: '2', label: 'Follow up 2' },
        { value: '3+', label: 'Follow up 3+' },
    ];

    // useAttendedScope=true delegates to the shared buildAttendedCountFilterQuery (constants/newLead.js)
    // which emits the status-scoped param for CONSULTATION_ATTENDED — one source of truth.
    // NoTaskTable always passes false (default) — unscoped output byte-identical to before.
    const buildCountFilterQuery = (val, useAttendedScope = false) => {
        if (!val) return '';
        if (useAttendedScope) return buildAttendedCountFilterQuery(val);
        if (val === '3+') return '&lead_treatments__lead_contacted_counts__count__gte=3';
        return `&lead_treatments__lead_contacted_counts__count=${val}`;
    };

    const handleContactedCountFilter = (event) => {
        const val = event.target.value;
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus: filterStatus || 'All',
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            tags: searchTags,
            referral,
            assigneeIds: assigneeData?.toString(),
            directCountFilter: buildCountFilterQuery(val, consultantAttendedType),
        };
        updateLeadPage(payloadData);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payloadData);
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, { contactedCountFilter: val, perPage: 10, pageNumber: 0 });
    };

    const tabCounter = (data) => counter?.filter((value) => (value.filterStatus === data ? value.count : null));

    const labelCount = (data, stripKind = 'contacted') => {
        // Checklist sub-strip items are keyed by `.value` ('in_progress'/'complete')
        // in the counter store — even on treatmentStarted, where the contacted-count
        // strip would otherwise key by `data?.id`. Branch so the checklist badge resolves.
        const response = tabCounter(stripKind === 'checklist' ? data.value : (treatmentStartedType ? data?.id : data.value));
        // C3 fix: the checklist sub-strip (In Progress / Follow-Up Complete) must
        // compare against checklistStateValue, NOT activeStripValue. activeStripValue
        // is the contacted-count strip's value (contactCount / filterStatus) and never
        // equals a checklist state, so the checklist chips' active styling never lit up.
        const isActive = stripKind === 'checklist'
            ? data.value === (checklistStateValue || 'in_progress')
            : (treatmentStartedType ? data?.id : data.value) === activeStripValue;
        const rawLabel = treatmentStartedType ? (data?.name || data?.label) : data?.label;
        // Resolve per-practice rename override (set via TableDefaults inline rename).
        // Falls through to rawLabel when no override exists or the parent isn't
        // mapped (treatmentStartedType, custom-tab values, etc.).
        const slug = stripParentForOverrides && stripSlugMap[String(data?.value)];
        // System-default cascade: resolveTabLabel falls back to the global record's
        // tab_label_overrides when the practice has no per-slug override. globalPrefForStrip
        // is computed inline because labelCount runs per-tab in the strip render — keeping
        // the lookup local avoids a useMemo that depends on a derived slice.
        const globalPrefForStrip = stripParentForOverrides
            ? selectGlobalPrefForTable(globalTablePreferencesForStrip, stripParentForOverrides)
            : null;
        const effectiveLabel = (slug && stripParentForOverrides)
            ? resolveTabLabel(practice?.preferences, stripParentForOverrides, slug, rawLabel, globalPrefForStrip)
            : rawLabel;
        return (
            <>
                <Box sx={{ fontWeight: '600' }}>
                    {/* The checklist sub-strip always shows its count badge (both
                        Attended and Treatment Started). The contacted-count top strip
                        stays suppressed on treatmentStarted/booked as before. */}
                    {(stripKind === 'checklist' || (noTreatmentStartedType && noConsultantBookedType)) && (
                        <Label
                            sx={{
                                m: '5px 8px',
                                color: isActive ? primary.main : (isLight ? common.slateGray : common.white),
                                background: isActive ? 'rgba(0, 167, 111, 0.08)' : (isLight ? grey[300] : common.stillBlue),
                            }}
                        >
                            {' '}
                            {(response && response[0]?.count) || 0}{' '}
                        </Label>
                    )}
                    <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                        {effectiveLabel}
                    </Box>
                    <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                        {(() => {
                            const name = effectiveLabel;
                            if (name === 'Waiting/Scheduled') return 'W/S';
                            if (name === 'Follow up 1') return 'FU1';
                            if (name === 'Follow up 2') return 'FU2';
                            if (name === 'Follow up 3 +' || name === 'Follow up 3+') return 'FU3+';
                            return name;
                        })()}
                    </Box>
                </Box>
            </>
        );
    };

    const { toggle: openAssignTask, onOpen: onOpenAssignTask, onClose: onCloseAssignTask } = useAssignTaskToggle();
    const {
        toggle: openTreatmentPlan,
        onOpen: onOpenOpenTreatmentPlan,
        onClose: onCloseTreatmentPlan,
    } = useAssignTaskToggle();

    const {
        toggle: openAppointmentAssignTask,
        onOpen: onOpenAppointmentAssignTask,
        onClose: onCloseAppointmentAssignTask,
    } = useAssignTaskToggle();
    const {
        toggle: openClinCheckStatus,
        onOpen: onOpenClinCheckStatus,
        onClose: onCloseClinCheckStatus,
    } = useAssignTaskToggle();

    const OpenAssignTask = (row, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        onOpenAssignTask();
        onCloseTreatmentEditPopup();
        setSelectedRowId(row?.lead_id);
    };
    const openClinCheckStatusPopup = (row, event) => {
        setAnchorClinCheck(anchorClinCheck ? null : event.currentTarget);
        onOpenClinCheckStatus();
        setSelectedRowId(row?.lead_id);
    };

    const openAppointmentAssignTaskFuc = (row, assignees, event, id) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget || event);
        onOpenAppointmentAssignTask();
        setSelectedRowId(row?.lead_id || row?.id);
        setAssignees(assignees);
        setAppoinmentSelectedId(id);
    };

    const onCloseAssignTaskPopup = (isReload, data) => {
        if (isReload) {
            setTableData((state) => state.map((ele) => {
                if (ele.id === data?.id) {
                    return { ...ele, assignees: data?.assignees };
                }
                return ele;
            }));
        }
        onCloseAssignTask();
    };

    const onCloseTreatmentPlanDatePicker = () => {
        handleReloadAPI('finish');
        onCloseTreatmentPlan();
    };

    const onCloseAppointmentAssignTaskPopup = (isReload, data) => {
        if (isReload) {
            handleSetTableData(data);
        }
        onCloseAppointmentAssignTask();
    };

    const handlePracticeFilter = (e, value) => {
        const data = {
            practices: value
        };
        let practiceArray = value?.map(e => e?.id);
        if (practiceArray && practiceArray?.length) {
            practiceArray = practiceArray?.join(",");
        } else {
            practiceArray = "";
        }
        dispatch(updateSuperAdmin(data));
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            practiceId: value,
            practices: practiceArray
        };
        handleStartedTablePayload(payloadData);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payloadData);
        }
        updateLeadPage(payloadData);
        UpdateTableData(type, { practices: practiceArray, perPage: 10, pageNumber: 0 });
        setValue('practices', value);
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });

    }

    const handleReferral = (e, data) => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral: data?.id ? "CLINICIAN" : data?.value,
            ...(data?.id ? { affiliate_user: data.affiliate_user, type: "CLINICIAN" } : {}),
            depositPendingStatus,
            practices,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false
        };
        handleStartedTablePayload(payloadData);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payloadData);
        }
        updateLeadPage(payloadData);
        UpdateTableData(type, { referral: data?.value, perPage: 10, pageNumber: 0 });
        setValue('referral', data?.id ? "CLINICIAN" : data?.value);
        if (data?.id) {
            setValue('affiliate_user', data?.id);
            setValue('type', "CLINICIAN");
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        syncToUrl(buildUrlFilterState({ referral: data?.id ? 'CLINICIAN' : data?.value }));
    };

    const handleArchiveFilter = (e, data) => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason: data?.value,
            noTreatment: false
        };
        handleStartedTablePayload(payloadData);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payloadData);
        }
        updateLeadPage(payloadData);
        UpdateTableData(type, { archiveReason: data?.value, perPage: 10, pageNumber: 0 });
        setValue('archiveReason', data?.value);
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        syncToUrl(buildUrlFilterState({ archiveReason: data?.value }));
    }
    const handleDepositPendingFilter = (e) => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus: e?.target?.value || '',
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false
        };
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payloadData);
        }
        updateLeadPage(payloadData);
        UpdateTableData(type, { depositPendingStatus: e?.target?.value || '', perPage: 10, pageNumber: 0 });
        setDepositPendingFilter(e?.target?.value || '');
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        syncToUrl(buildUrlFilterState({ depositPaid: e?.target?.value || '' }));
    };

    const handleCloseTreatment = () => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: notAllType ? contactCount : filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false
        };
        updateLeadPage(payloadData);
        if (tableData && reloadCounter) {
            reloadCounter(payloadData);
        }
        document.body.classList.remove('points-event');
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
    };

    const referralValue = () => referralData?.filter((data) => data.value === referral);
    const archiveReasonValue = () => archiveReasonData?.filter((data) => data.value === archiveReason);

    const handleCategory = (e, newValue) => {
        const data = {
            limit: 30,
            offset: 0,
            category: e?.target?.innerText !== 'All' ? e?.target?.innerText : null,
            callBack: () => setCheckOptions(true),
        };
        dispatch(getPracticeTreatmentList(practiceId, data));
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: notAllType ? contactCount : filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: '',
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category: newValue,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason
        };
        updateLeadPage(payloadData);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payloadData);
        }
        UpdateTableData(type, {
            treatment: [],
            category: newValue,
            categoryName: e?.target?.innerText !== 'All' ? e?.target?.innerText : '',
            perPage: 10,
            pageNumber: 0,
        });
    };

    useEffect(() => {
        if (results && checkOptions) {
            const data = treatmentValue.filter((el) => results.map((elem) => elem?.id).includes(el?.id) && el);
            UpdateTableData(type, { treatment: data, perPage: 10, pageNumber: 0 });
            setCheckOptions(false);
        }
    }, [checkOptions]);

    const dateChange = (newValue, shouldNotCall) => {
        setDate(newValue);
        if (!shouldNotCall && dashBoardDateProps?.dateChange) {
            dashBoardDateProps.dateChange(newValue);
        }
        if (shouldRunEffect) {
            shouldRunEffect.current = false;
        }
        const startDate = newValue[0] ? moment(newValue[0]?.$d, 'YYYY-MM-DD').format('YYYY-MM-DD') : '';
        const endDate = newValue[1] ? moment(newValue[1]?.$d, 'YYYY-MM-DD').format('YYYY-MM-DD') : '';
        if (startDate && endDate) {
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus: notAllType ? contactCount : filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false
            };
            updateLeadPage(payloadData);
            if (tableData && practiceId && reloadCounter) {
                reloadCounter(payloadData);
            }
        }

        if (newValue[0] === null && newValue[1] === null) {
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus: notAllType ? contactCount : filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate: null,
                endDate: null,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false
            };
            updateLeadPage(payloadData);
            if (tableData && practiceId && reloadCounter) {
                if (!shouldNotCall && dashType) {
                    reloadCounter({ ...payloadData, isComeFromDateChange: true });
                } else {
                    reloadCounter(payloadData);
                }
            }
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, { date: [{ startDate, endDate }], pageNumber: 0, perPage: 10 });
        syncToUrl(buildUrlFilterState({ startDate: startDate || '', endDate: endDate || '' }));
        // Persist date range in sessionStorage per table type
        try {
            if (startDate && endDate) {
                sessionStorage.setItem(sessionDateKey, JSON.stringify({ startDate, endDate }));
            } else {
                sessionStorage.removeItem(sessionDateKey);
            }
        } catch { /* ignore storage errors */ }
    };

    // Expose date range controls to parent (for inline calendar in page heading)
    useEffect(() => {
        if (onDateRangeReady) {
            onDateRangeReady({ date, dateChange, setDate, startDate, endDate });
        }
    }, [date, startDate, endDate]);

    useEffect(() => {
        if (shouldRunEffect && shouldRunEffect.current) {
            const today = moment();
            if (today.isSame(dashBoardDateProps?.startDateDashboard, 'day') && today.isSame(dashBoardDateProps?.endDateDashboard, 'day')) {
                dateChange([null, null], true);
                return;
            }
            dateChange(dashBoardDateProps.date, true);
        }
    }, [dashBoardDateProps?.date]);

    const handlePage = () => {
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
    };

    // const practiceUserId = (e) =>
    //     practiceUser.results.filter((el) =>
    //         e?.includes(`${el?.user?.salutation || ''} ${el?.user?.first_name || ''} ${el?.user?.last_name || ''}`)
    //     )[0]?.user.id;

    const handlePractitioner = (e, value) => {
        const ids = [];
        value.map((data) => ids.push(data.id));
        setValue('bookedWith', value);
        dispatch(updateCounter([]));
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: ids?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false
        };
        const updatedTableData = {
            bookedWith: value, pageNumber: 0, perPage: 10,
        };
        if (treatmentStartedType) {
            setValue('consultationBookedWith', []);
            payloadData.apptType = ids.length ? 'TREATMENT' : '';
            payloadData.consultationBookedWith = '';
            updatedTableData.apptType = ids.length ? 'TREATMENT' : '';
            updatedTableData.consultationBookedWith = []
        }

        updateLeadPage(payloadData);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payloadData);
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, updatedTableData);
        syncToUrl(buildUrlFilterState({ bookedWith: value }));
    };
    const handleConsultationBookedWith = (e, value) => {
        const ids = [];
        value.map((data) => ids.push(data.id));
        setValue('consultationBookedWith', value);
        setValue('bookedWith', []);
        dispatch(updateCounter([]));
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: '',
            consultationBookedWith: ids?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false
        };
        updateLeadPage({ ...payloadData, apptType: ids.length ? 'CONSULTATION' : '' });
        if (tableData && practiceId && reloadCounter) {
            reloadCounter({ ...payloadData, apptType: ids.length ? 'CONSULTATION' : '' });
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, { bookedWith: [], consultationBookedWith: value, apptType: ids.length ? 'CONSULTATION' : '', pageNumber: 0, perPage: 10 });
        syncToUrl(buildUrlFilterState({ consultationBookedWith: value, bookedWith: [] }));
    };

    const handleTags = (data, tags) => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: '',
            startDate,
            endDate,
            contactedCount: contactCount,
            tags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason
        };
        handleStartedTablePayload(payloadData);
        updateLeadPage(payloadData);
        if (tableData && practiceId && reloadCounter) {
            reloadCounter(payloadData);
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, { tag: data, filterTags: tags, perPage: 10, pageNumber: 0 });
        syncToUrl(buildUrlFilterState({ tags: data }));
    };

    const onSelectionModelChange = (newSelectionModel) => {
        const updatedData = tableData.map((item) => {
            if (item.lead_id && !item.is_archive_pending) {
                const checked = newSelectionModel.includes(item.lead_id);
                return { ...item, checked };
            }
            return item;
        });
        setTableData(updatedData);
        dispatch(
            selectLeads({
                leadId: newSelectionModel,
                type: archType ? 'Restore' : 'Archive',
                loading: false,
            })
        );
    };

    const handleClearReportTable = () => {
        if (onClose) {
            onClose(true);
        }
        UpdateTableData(type, {
            search: '',
            date: [],
            treatment: [],
            perPage: 10,
            pageNumber: 0,
            tag: [],
            filterTags: [],
            referral: '',
            practices: '',
            bookedWith: '',

        });
    };

    const isDisabled = () => {
        if (loadingForLead) {
            return { pointerEvents: 'none', opacity: 0.5 };
        }
        return {};
    };

    const handleDepositPendingChange = (e) => {
        setDepositStatus(e.target.checked);
        let treatment = '';
        let id = '';
        const latestData = handleLatestData({ lead_treatments: selectedRow.treatmentData || [] }, type, rowStatus);
        if (isArray(latestData) && latestData.length > 0) {
            treatment = latestData[0]?.treatment;
            id = latestData[0]?.id;
        } else {
            return;
        }
        const data = {
            leadId: selectedRow.lead_id,
            treatmentId: id,
            payload: {
                treatment,
                is_treatment_fee_pending: !e.target.checked,
            },
        };
        dispatch(startLoadingDepositPending(true));
        dispatch(UpdateDepositPendingStatus(data, handleReloadLeads));
    };

    const handleCloseStartTreatment = () => {
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        setStartConfirmation(false);
    };

    const onWidgetClick = (value) => {
        if (newType) {
            handleChangeStatus('', value);
            return;
        }
        // Handle new booked table widget keys (string values)
        if (consultantBookedType && typeof value === 'string') {
            // Set the booked widget filter and reload data
            const newFilter = bookedWidgetFilter === value ? null : value;
            setBookedWidgetFilter(newFilter);
            setPaginationModel({ pageSize: 10, page: 0 });
            setPage(0);
            const payloadData = {
                limit: 10,
                offset: 0,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                bookedWith: bookedWithData?.toString(),
                depositPendingStatus,
                assigneeIds: assigneeData?.toString(),
                noTreatment: false,
                bookedWidgetFilter: newFilter
            };
            updateLeadPage(payloadData);
            return;
        }
        if (consultantBookedType || failedToAttendType || treatmentStartedType || consultantAttendedType || attendedChecklistsType || consultantClinCheckAttendedType) {
            handleTreatment('', value);
        }
    };
    const handleClickAwayLister = (e, popup1Ref) => {
        if (popup1Ref && popup1Ref.current) {
            if (!popup1Ref.current?.contains(e.target)) {
                onClosePracticePopup();
                onCloseTreatmentEditPopup();
                setAnchorElAssign(null);
                return;
            }
            return;
        }
        onClosePracticePopup();
        onCloseTreatmentEditPopup();
        setAnchorElAssign(null);
    };

    const handleCloseAddTreatment = (e, popup1Ref) => {
        if (popup1Ref && popup1Ref.current) {
            if (!popup1Ref.current?.contains(e.target)) {
                onCloseAddTreatment();
                setAnchorElAssign(null);
                return;
            }
            return;
        }
        onCloseAddTreatment();
        setAnchorElAssign(null);
    };

    const handleCloseAssignPopup = (isReload, data) => {
        onCloseAssignTaskPopup(isReload, data);
        setAnchorElAssign(null);
    };
    const handleCloseAppointmentAssignPopup = (isReload, data) => {
        onCloseAppointmentAssignTaskPopup(isReload, data);
        setAnchorElAssign(null);
    };

    const onClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAssignTask();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const appointmentClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAppointmentAssignTaskPopup();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const handleDepositPaymentOnclose = (leadId) => {
        onCloseDepositPaymentPopup();
        paymentDeleteToggle.onClose();
        if (leadId) {
            dispatch(followUpSlice(leadId, practiceId, 'LeadDetail', (data) => handleSetTableData(data)));
        }
    };

    const onCloseClickCheckPopup = (data) => {
        onCloseClinCheckStatus(data);
        setAnchorClinCheck(null);
    };

    return (
        <>
            <Helmet>
                <title> {`${noDashType ? tableTitle : displayForCategorySummary ? 'Category Summary' : 'Dashboard'}`} | Dental SEM CRM</title>
            </Helmet>
            {reportData && (
                <Box sx={{ textAlign: 'right' }}>
                    <Button variant='outlined' onClick={handleClearReportTable}>
                        Cancel
                    </Button>
                </Box>
            )}
            <Box sx={{ mb: reportData ? 0 : 5 }}>
                {allType && !isNoTaskLeadsTable && !displayForCategorySummary && tableTitle !== 'All Patients' && < DashBoardReportsWidget
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                    activeWidgetProps={{ currentWidget, setCurrentWidget }}
                    widgetToggle={widgetToggleProp}
                />}
                {newType && !displayForCategorySummary && <NewLeadTableReportsWidget
                    counter={counter}
                    onWidgetClick={onWidgetClick}
                    currentSelectedTab={activeStripValue}
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                    widgetToggle={widgetToggleProp}
                />}
                {consultantBookedType && !displayForCategorySummary && <BookedTableReportsWidget
                    onWidgetClick={onWidgetClick}
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                    selectedWidget={bookedWidgetFilter}
                    widgetToggle={widgetToggleProp}
                />}
                {failedToAttendType && !displayForCategorySummary && <FTATableReportsWidget
                    onWidgetClick={onWidgetClick}
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                    widgetToggle={widgetToggleProp}
                />}
                {treatmentStartedType && selectedTab !== 'invisalignAdditional' && !displayForCategorySummary &&
                    <StartedTableReportsWidget
                        onWidgetClick={onWidgetClick}
                        dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                        tableTitle={tableTitle}
                        widgetToggle={widgetToggleProp}
                    />}
                {(consultantAttendedType || attendedChecklistsType) && !displayForCategorySummary && <AttendedTableReportsWidget
                    onWidgetClick={onWidgetClick}
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                    widgetToggle={widgetToggleProp}
                />}
                {(consultantClinCheckAttendedType) && !displayForCategorySummary && !onDateRangeReady && <Box sx={{ mb: 2 }}>
                    <MultiDatePicker
                        value={date}
                        endDate={new Date()}
                        dateChange={dateChange}
                        setValue={setDate}
                        startDateValue={startDate}
                        endDateValue={endDate}
                        inputFieldType='button'
                    />
                </Box>}
                <Card sx={{ bgcolor: 'background.paper', padding: '0', border: '1px solid', borderColor: 'divider', boxShadow: '0 1px 3px 0 rgba(0,0,0,0.04)', ...isDisabled() }}>
                    {isReportData && !displayForCategorySummary && !hideCounterTabs && commonType && notClinCheckType && tableTitle !== 'Aligner Approve Leads' && tableTitle !== 'All Patients' && selectedTab !== 'invisalignAdditional' && (type === 'ConsultantAttend' ? displayedHeadings.length > 1 : displayedHeadings.length > 0) && (
                        <Tabs
                            allowScrollButtonsMobile
                            variant='scrollable'
                            scrollButtons='auto'
                            value={activeStripValue}
                            onChange={handleChangeStatus}
                            sx={tabsStyle}
                        >
                            {displayedHeadings.map((item) => (
                                <Tab
                                    sx={{
                                        ...tabStyle(
                                            type,
                                            item,
                                            item?.value === 'AWAITING_RESPONSE'
                                                ? noAwatingCount && noAwatingCount[0]?.count
                                                : nhsCount && nhsCount[0]?.count
                                        ),
                                    }}
                                    disableRipple
                                    key={treatmentStartedType ? item?.id : item.value}
                                    label={labelCount(item)}
                                    value={treatmentStartedType ? item?.id : item.value}
                                />
                            ))}
                        </Tabs>
                    )}
                    {/* Task #100 Risk 2 — Second strip rendered ADDITIVELY below
                        the normal contacted-count strip when a top-placement
                        custom tab has checklist_binding active. Composes with
                        the first strip via checklistState query param. */}
                    {isReportData && !displayForCategorySummary && !hideCounterTabs && checklistStripActive && type !== 'AttendedChecklists' && (
                        <Tabs
                            allowScrollButtonsMobile
                            variant='scrollable'
                            scrollButtons='auto'
                            value={checklistStateValue || 'in_progress'}
                            onChange={handleChangeChecklistState}
                            sx={tabsStyle}
                        >
                            {ATTENDED_CHECKLISTS_TAB_HEAD.map((item) => (
                                <Tab
                                    sx={{ ...tabStyle(type, item, 0) }}
                                    disableRipple
                                    key={item.value}
                                    label={labelCount(item, 'checklist')}
                                    value={item.value}
                                />
                            ))}
                        </Tabs>
                    )}
                    {isReportData && selectedTab !== 'invisalignAdditional' && !displayForCategorySummary && (
                        <Box>
                            {showPracticeColumn ? (<Stack
                                className='filter-toggle-stack'
                                sx={stackStyle}
                                alignItems='left'
                                direction={{
                                    xs: 'column',
                                    md: 'row',
                                }}
                            >
                                {
                                    <Box sx={treatmentTagFilterStyle}>
                                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                            <Box sx={filterFormBoxStyle}>
                                                <Box sx={searchWrapperStyle}>
                                                    <TextField
                                                        fullWidth
                                                        onChange={(event) => handleSearch(event.target.value)}
                                                        value={search}
                                                        sx={textFieldStyle}
                                                        placeholder='Search Lead Name, Email & Phone'
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position='start'>
                                                                    <Iconify
                                                                        icon={'eva:search-fill'}
                                                                        sx={{ color: 'text.disabled', width: 20, height: 20 }}
                                                                    />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Box>
                                                <Box sx={referralOutBoxStyle}>
                                                    <ReferralDropdown
                                                        name={'referral'}
                                                        value={referralValue()[0]?.label || ''}
                                                        onChange={handleReferral}
                                                        sx={{ ...referralBoxStyle }}
                                                        type={'search'}
                                                        affiliateUser={rowLead.current?.lead_source?.affiliate_user}
                                                    />
                                                </Box>
                                                <Box sx={referralOutBoxStyle}>
                                                    <PracticeDropdowns
                                                        name={'practices'}
                                                        label="Select Practices"
                                                        onChange={handlePracticeFilter}
                                                        value={superData?.practices || []}
                                                    />
                                                </Box>
                                            </Box>
                                        </FormProvider>
                                    </Box>
                                }
                            </Stack>) : (<Box
                                className='filter-toggle-stack'
                                sx={{ ...stackStyle, flexDirection: 'column', mt: '8px', mb: '6px' }}
                            >
                                {
                                    <Box sx={treatmentTagFilterStyle}>
                                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                            {/* V3 — Unified filter bar with inline clear */}
                                            <Box sx={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '8px',
                                                alignItems: 'center',
                                                py: '4px',
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    height: 34,
                                                    fontSize: '12px',
                                                    borderRadius: '8px',
                                                    '& fieldset': { borderColor: 'rgba(145, 158, 171, 0.20)' },
                                                    '&:hover fieldset': { borderColor: 'rgba(145, 158, 171, 0.40)' },
                                                    '&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: '1.5px' },
                                                },
                                                '& .MuiInputBase-input': { fontSize: '12px', py: '5px !important' },
                                                '& .MuiInputLabel-root': { fontSize: '12px', color: 'rgba(145, 158, 171, 0.7)' },
                                                '& .MuiInputLabel-shrink': { top: '0' },
                                                '& .MuiTextField-root > .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { top: '-8px' },
                                                '& .MuiFormControl-root:not(.MuiTextField-root) > .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { top: '-1px' },
                                                '& .MuiAutocomplete-inputRoot': { py: '2px !important', pr: '8px !important' },
                                                '& .MuiAutocomplete-endAdornment': { top: '50% !important', transform: 'translateY(-50%)' },
                                                '& .MuiSelect-select': { py: '5px !important', fontSize: '12px' },
                                                '& .MuiSelect-icon': { top: '50% !important', transform: 'translateY(-50%)' },
                                            }}>
                                                <Box sx={{ ...searchWrapperStyle, flex: '1.5 1 200px', maxWidth: 320 }}>
                                                    <TextField
                                                        fullWidth
                                                        size='small'
                                                        onChange={(event) => handleSearch(event.target.value)}
                                                        value={search}
                                                        sx={{
                                                            ...textFieldStyle,
                                                            '& .MuiOutlinedInput-root': {
                                                                ...textFieldStyle['& .MuiOutlinedInput-root'],
                                                                height: 34,
                                                                borderRadius: '8px',
                                                            },
                                                        }}
                                                        placeholder='Search name, email, phone'
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position='start'>
                                                                    <Iconify
                                                                        icon={'eva:search-fill'}
                                                                        sx={{ color: 'text.disabled', width: 16, height: 16 }}
                                                                    />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Box>

                                                {isMobileFilters && (
                                                    <Box
                                                        component="button"
                                                        onClick={() => setMobileFiltersExpanded(!mobileFiltersExpanded)}
                                                        sx={{
                                                            display: 'flex', alignItems: 'center', gap: '4px',
                                                            px: '12px', py: '8px', borderRadius: '8px',
                                                            border: '1px solid rgba(145,158,171,0.24)',
                                                            bgcolor: mobileFiltersExpanded ? 'rgba(0,167,111,0.08)' : 'transparent',
                                                            color: mobileFiltersExpanded ? '#007B55' : '#637381',
                                                            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
                                                            width: '100%', justifyContent: 'center', mt: 1,
                                                        }}
                                                    >
                                                        {mobileFiltersExpanded ? 'Hide Filters' : 'Filters'}
                                                    </Box>
                                                )}

                                                {(!isMobileFilters || mobileFiltersExpanded) && <>

                                                {tableTitle !== 'Aligner Approve Leads' && !hiddenFilters.includes('treatments') && <MultiTreatmentDropdown
                                                    name={'multiSelect'}
                                                    label='Treatments'
                                                    sx={{ ...treatmentBoxStyle, flex: '1 1 140px' }}
                                                    onChange={handleTreatment}
                                                    value={treatmentValue}
                                                    type={type}
                                                />}

                                                {!hiddenFilters.includes('referral') && <Box sx={{ ...referralOutBoxStyle, flex: '1 1 120px' }}>
                                                    <ReferralDropdown
                                                        name={'referral'}
                                                        value={referralValue()[0]?.label || ''}
                                                        onChange={handleReferral}
                                                        sx={{ ...referralBoxStyle }}
                                                        type={'search'}
                                                        affiliateUser={rowLead.current?.lead_source?.affiliate_user}
                                                    />
                                                </Box>}

                                                {!hiddenFilters.includes('assignees') && <MultiAssigneesDropdown
                                                    name={'multiSelectAssignee'}
                                                    label='Assignees'
                                                    sx={{ ...treatmentBoxStyle, flex: '1 1 130px' }}
                                                    onChange={handleAssigneeFilter}
                                                    value={assigneeSelectedForFilter}
                                                    type={type}
                                                />}

                                                {bookedWithFilter && !hiddenFilters.includes('booked-with') && (
                                                    <MultiAssigneesDropdown
                                                        name={'bookedWith'}
                                                        label={treatmentStartedType && tableTitle !== 'Aligner Approve Leads' ? 'Tx booked with' : 'Booked with'}
                                                        sx={{ ...treatmentBoxStyle, flex: '1 1 130px' }}
                                                        onChange={(e, value) => handlePractitioner(e, value)}
                                                        value={bookedWith}
                                                        type={type}
                                                    />
                                                )}

                                                {treatmentStartedType && type !== "treatmentStartedWithInvisalign" && !hiddenFilters.includes('consult-booked-with') && (
                                                    <MultiAssigneesDropdown
                                                        name={'consultationBookedWith'}
                                                        label='Consult booked with'
                                                        sx={{ ...treatmentBoxStyle, flex: '1 1 150px' }}
                                                        onChange={(e, value) => handleConsultationBookedWith(e, value)}
                                                        value={consultationBookedWith}
                                                        type={type}
                                                    />
                                                )}

                                                {(isNoTaskLeadsTable || consultantAttendedType) && !hiddenFilters.includes('contacted') && (
                                                    <Box sx={{ flex: '1 1 120px' }}>
                                                        <FormControl fullWidth size='small'>
                                                            <InputLabel>Contacted</InputLabel>
                                                            <Select
                                                                value={contactedCountFilterValue}
                                                                label='Contacted'
                                                                onChange={handleContactedCountFilter}
                                                            >
                                                                {CONTACTED_COUNT_OPTIONS.map((opt) => (
                                                                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                )}

                                                {(type === 'ConsultantAttend' || type === 'AttendedChecklists' || type === 'ConsultantClinCheckAttend' || type === 'ConsultantBooked') && !hiddenFilters.includes('deposit') && (
                                                    <Box sx={{ flex: '1 1 110px' }}>
                                                        <FormControl fullWidth size='small'>
                                                            <InputLabel>Deposit</InputLabel>
                                                            <Select
                                                                value={depositPendingStatus}
                                                                label='Deposit'
                                                                onChange={handleDepositPendingFilter}
                                                            >
                                                                <MenuItem value={'YES'}>Yes</MenuItem>
                                                                <MenuItem value={'NO'}>No</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                )}

                                                {type === "ArchiveTable" && !hiddenFilters.includes('archive-reason') && (
                                                    <Box sx={{ ...referralOutBoxStyle, flex: '1 1 120px' }}>
                                                        <SelectArchiveReasons
                                                            name={'archive'}
                                                            value={archiveReasonValue()[0]?.label || ''}
                                                            onChange={handleArchiveFilter}
                                                            sx={{ ...referralBoxStyle }}
                                                            type={'search'}
                                                            archiveReasonData={archiveReasonData}
                                                        />
                                                    </Box>
                                                )}

{!hiddenFilters.includes('tags') && <Box sx={{ flex: '1 1 120px' }}>
                                                    <SearchAutocompleteTags
                                                        updateLeadPage={updateLeadPage}
                                                        tableType={type}
                                                        reloadCounter={reloadCounter}
                                                        handlePage={handlePage}
                                                        handleStartedTablePayload={handleStartedTablePayload}
                                                    />
                                                </Box>}

                                                {hasActiveFilters && (
                                                    <>
                                                        <Box sx={{ width: '1px', height: 20, bgcolor: 'rgba(145, 158, 171, 0.20)', alignSelf: 'center', mx: 0.5, flexShrink: 0 }} />
                                                        <Button
                                                            size='small'
                                                            onClick={onResetFilter}
                                                            startIcon={<Iconify icon='solar:close-circle-bold' width={14} />}
                                                            sx={{
                                                                height: 30,
                                                                fontSize: '12px',
                                                                fontWeight: 600,
                                                                px: 1,
                                                                borderRadius: '6px',
                                                                color: 'error.main',
                                                                bgcolor: 'rgba(255, 86, 48, 0.06)',
                                                                '&:hover': { bgcolor: 'rgba(255, 86, 48, 0.14)' },
                                                                whiteSpace: 'nowrap',
                                                                minWidth: 'auto',
                                                                textTransform: 'none',
                                                                flexShrink: 0,
                                                            }}
                                                        >
                                                            Clear
                                                        </Button>
                                                    </>
                                                )}

                                                </>}
                                            </Box>
                                        </FormProvider>
                                    </Box>
                                }
                            </Box>)}
                            {showPracticeColumn && (tableTitle === 'All Patients' || multiLead?.leadId?.length === 0) && (
                                <Stack
                                    className='filter-toggle-stack'
                                    sx={searchFilterContent}
                                    alignItems='left'
                                    direction={{
                                        xs: 'column',
                                        md: 'row',
                                    }}
                                >
                                    <TableFilterResult
                                        filters={filters}
                                        onResetFilters={onResetFilter}
                                        onReset={
                                            searchValue ||
                                            treatmentValue?.length > 0 ||
                                            startDate ||
                                            endDate ||
                                            referral?.length > 0 ||
                                            bookedWith?.length > 0 ||
                                            depositPendingStatus ||
                                            consultationBookedWith?.length > 0 ||
                                            assigneeSelectedForFilter?.length > 0 ||
                                            archiveReason?.length > 0 ||
                                            practices?.length > 0
                                        }
                                        isTreatmentStarted={treatmentStartedType && type !== "treatmentStartedWithInvisalign"}
                                        handleTreatment={handleTreatment}
                                        handleReferral={handleReferral}
                                        dateChange={dateChange}
                                        handleTags={handleTags}
                                        handlePractitioner={handlePractitioner}
                                        handleDepositPendingFilter={handleDepositPendingFilter}
                                        handleConsultationBookedWith={handleConsultationBookedWith}
                                        tableTitle={tableTitle}
                                        handleAssigneeFilter={handleAssigneeFilter}
                                        handleArchiveFilter={handleArchiveFilter}
                                        selectedCount={tableTitle === 'All Patients' ? (multiLead?.leadId?.length || 0) : 0}
                                    />
                                </Stack>
                            )}
                        </Box>
                    )}
                    <Box sx={{ borderTop: 'solid 1px rgba(145, 158, 171, 0.16)' }}>
                        {checklistEmptyStateProbeEnabled
                            && (tableData?.length || 0) === 0
                            && !loadingForLead
                            ? (attendedChecklistsType ? (
                                <EmptyContent
                                    filled
                                    title="No checklist data yet"
                                    description="This practice has Tasks v2 enabled but no checklist templates configured, or no tasks have been auto-created yet."
                                    sx={{ py: 6, my: 2 }}
                                    action={
                                        <Button
                                            component={RouterLink}
                                            to={PATH_DASHBOARD.superAdmin.systemTaskTemplates}
                                            variant="contained"
                                            startIcon={<Iconify icon="solar:clipboard-list-bold" />}
                                            sx={{ mt: 2 }}
                                        >
                                            Go to System Task Templates
                                        </Button>
                                    }
                                />
                            ) : (
                                <EmptyContent
                                    filled
                                    title="No leads in this checklist state yet"
                                    description="This tab is bound to checklist template(s). Either no tasks have been created on attended leads yet, or all leads are in a different sub-tab. Try switching sub-tabs or wait for the next attended consultation."
                                    sx={{ py: 6, my: 2 }}
                                />
                            ))
                            : tableTitle === 'Aligner Approve Leads' ?
                            <AlignerApproveLeadDataGrid
                                tableTitle={tableTitle}
                                tableData={tableData}
                                typed={type}
                                isReportData={isReportData}
                                selectedRow={onSelectedRow}
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                handlePaginationChange={handlePaginationChange}
                                pageCount={pageCount}
                                handleChangePerSize={(event) => handleChangePerPage(event)}
                                OpenAssignTask={OpenAssignTask}
                                reloadCounter={reloadCounter}
                                updateLeadPage={updateLeadPage}
                                onSelectionModelChange={onSelectionModelChange}
                                isNotFound={isNotFound}
                                onOpenOpenTreatmentPlan={onOpenOpenTreatmentPlan}
                                forceUpdate={forceUpdate}
                                tablePath={currentPagePath}
                                sortingApiCall={sortingApiCall}
                                defaultHideColumn={defaultHideColumn}
                                columnVisibilityModel={columnVisibilityModel}
                                handleColumnVisibilityChange={handleColumnVisibilityChange}
                                handleColumnOrderChange={handleColumnOrderChange}
                                openAppointmentAssignTaskFuc={openAppointmentAssignTaskFuc}
                                handleReloadAPI={handleReloadAPI}
                                setTableData={setTableData}
                                handleSetTableData={handleSetTableData}
                                setCurrentTreatmentData={setCurrentTreatmentData}
                                setColumnVisibilityModel={setColumnVisibilityModel}
                                selectedTab={selectedTab}
                                isCombinedName={isCombinedName}
                                handleToggleCombineName={handleToggleCombineName}
                                setIsCombinedName={setIsCombinedName}
                                isEnforcedByPractice={isEnforcedByPractice}
                                setIsEnforcedByPractice={setIsEnforcedByPractice}
                                resetColumns={pinProps?.resetColumns}
                            /> :
                            <NewLeadDataGrid
                                tableTitle={tableTitle}
                                tableData={tableData}
                                typed={type}
                                customTabOverride={activeCustomTab?.column_overrides || null}
                                activeCustomTabSlug={activeCustomTab?.slug || undefined}
                                forceLoading={displayForCategorySummary && leadCategoryType !== filterStatus}
                                isReportData={isReportData}
                                selectedRow={onSelectedRow}
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                handlePaginationChange={handlePaginationChange}
                                pageCount={pageCount}
                                handleChangePerSize={(event) => handleChangePerPage(event)}
                                OpenAssignTask={OpenAssignTask}
                                reloadCounter={reloadCounter}
                                updateLeadPage={updateLeadPage}
                                refreshTable={refreshTableWithCurrentFilters}
                                refreshCounters={refreshCountersOnly}
                                removeRowOptimistically={removeRowOptimistically}
                                restoreRowOptimistically={restoreRowOptimistically}
                                onSelectionModelChange={onSelectionModelChange}
                                isNotFound={isNotFound}
                                onOpenOpenTreatmentPlan={onOpenOpenTreatmentPlan}
                                forceUpdate={forceUpdate}
                                tablePath={currentPagePath}
                                sortingApiCall={sortingApiCall}
                                defaultHideColumn={defaultHideColumn}
                                columnVisibilityModel={columnVisibilityModel}
                                handleColumnVisibilityChange={handleColumnVisibilityChange}
                                handleColumnOrderChange={handleColumnOrderChange}
                                openAppointmentAssignTaskFuc={openAppointmentAssignTaskFuc}
                                handleReloadAPI={handleReloadAPI}
                                setTableData={setTableData}
                                handleSetTableData={handleSetTableData}
                                setCurrentTreatmentData={setCurrentTreatmentData}
                                setColumnVisibilityModel={setColumnVisibilityModel}
                                pinProps={pinProps}
                                showPracticeColumn={showPracticeColumn}
                                hasActiveFilters={hasActiveFilters}
                                onClearFilters={onResetFilter}
                                isCombinedName={isCombinedName}
                                handleToggleCombineName={handleToggleCombineName}
                                setIsCombinedName={setIsCombinedName}
                                activeSubTab={contactCount ? String(contactCount) : undefined}
                                // Task #100 follow-up (Raj 2026-05-25, practice 92):
                                // suppress the dynamic checklist columns on the "All" /
                                // built-in parent views of ConsultantAttend AND
                                // TreatmentStarted (Raj 2026-05-28 — mixed-treatment built-in
                                // boards are too noisy with every show_in_tables template
                                // stacked together). Those views have no checklist_binding so
                                // they would otherwise inherit every template configured via
                                // `show_in_tables` and leak the per-custom-tab checklist UI
                                // onto the unfiltered list. Custom-top tabs
                                // (controlledCustomTabId is a number) keep their
                                // checklist_binding-resolved columns.
                                suppressTaskChecklistColumns={
                                    (type === 'ConsultantAttend' || type === 'treatmentStarted')
                                    && controlledCustomTabId !== undefined
                                    && controlledCustomTabId === null
                                }
                                checklistSwitching={isChecklistSwitching}
                                onChecklistSwitchingDone={() => setIsChecklistSwitching(false)}
                                onBulkCompleteReady={setBulkCompleteAnimate}
                            />
                        }

                    </Box>
                </Card>
                <CustomConfirmationDialog
                    toggle={paymentDeleteToggle.toggle}
                    handleClose={() => paymentDeleteToggle.onClose()}
                    handleSubmit={() => handleDeletePaymentMethods(selectedRow, handleDepositPaymentOnclose)}
                    message={'Are you sure you want to delete this payment?'}
                />
                {openContacts && <PracticeEditDialog open={openContacts} onClose={onCloseContacts} />}
                {openFollowLead && (
                    <OpenDialogPopup
                        open={openFollowLead}
                        headerButtons
                        onClose={handleClose}
                        openArchivePopup={onOpenArchiveLead}
                        user={selectedRow}
                        steps={leadStep}
                        type={'followup'}
                        validStep={validStep}
                        BookingAttendance={BookingAttendance}
                        updateStep={() => setValidStep(!validStep)}
                        inputRef={inputRef}
                        active={active}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        setActive={setActive}
                        ContactedCount={
                            selectedRow &&
                            selectedRow?.lead_treatments &&
                            selectedRow?.lead_treatments[0]?.lead_contacted_counts?.length > 0 &&
                            selectedRow?.lead_treatments[0]?.lead_contacted_counts[0]?.count
                        }
                        timeLineCount={activityList?.results?.length}
                    />
                )}
                {/* {New flow popup} */}
                {openContactLead && (
                    <OpenContactLeadPopup
                        open={openContactLead}
                        headerButtons
                        onClose={handleClose}
                        openArchivePopup={onOpenArchiveLead}
                        user={selectedRow}
                        steps={leadStep}
                        type={'followup'}
                        validStep={validStep}
                        BookingAttendance={BookingAttendance}
                        updateStep={() => setValidStep(!validStep)}
                        inputRef={inputRef}
                        active={active}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        setActive={setActive}
                        handleReloadLeads={handleReloadLeads}
                        ContactedCount={
                            selectedRow &&
                            selectedRow?.treatmentData &&
                            selectedRow?.treatmentData[0]?.lead_contacted_counts?.length > 0 &&
                            selectedRow?.treatmentData[0]?.lead_contacted_counts[0]?.count
                        }
                        timeLineCount={activityList?.results?.length}
                        defaultTab={contactLeadDefaultTab}
                    />
                )}
                {openConsultationAttend && (
                    <OpenConsultationPopup
                        open={openConsultationAttend}
                        headerButtons
                        onClose={() => onCloseConsultationAttend()}
                        handleCloseAndReload={handleClose}
                        handleReloadLeads={handleReloadLeads}
                        user={selectedRow}
                        type={'consultationAttended'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        startTreatment={startTreatment}
                        OpenAssignTask={openAppointmentAssignTaskFuc}
                        editDetailHandler={editDetailHandler}
                        selectedTreatmentData={currentTreatmentData}
                        defaultTab="Follow Up"
                    />
                )}
                {openRecordAttend && (
                    <OpenAttendedPopup
                        open={openRecordAttend}
                        headerButtons
                        onClose={() => onCloseRecordAttend()}
                        handleCloseAndReload={handleClose}
                        user={selectedRow}
                        type={'recordAttended'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        OpenAssignTask={openAppointmentAssignTaskFuc}
                        editDetailHandler={editDetailHandler}
                        handleReloadLeads={handleReloadLeads}
                        isOverview
                        handleNoAttended={() => { onCloseRecordAttend(); onOpenUnRecordAttend(); }}
                    />
                )}
                {openAttendedNote && (
                    <AttendedNotePopup
                        open={openAttendedNote}
                        headerButtons
                        onClose={() => onCloseAttendedNote()}
                        handleCloseAndReload={handleClose}
                        user={selectedRow}
                        type={'backtoAttended'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                    />
                )}
                {openUnRecordAttend && (
                    <OpenUnAttendedPopup
                        open={openUnRecordAttend}
                        headerButtons
                        onClose={() => onCloseUnRecordAttend()}
                        handleCloseAndReload={handleClose}
                        user={selectedRow}
                        type={'recordUnAttended'}
                        tableType={type}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                    />
                )}
                {openArchiveLead && (
                    <ArchivedLeadPopUp
                        open={openArchiveLead}
                        headerButtons
                        onClose={handleArchivedClose}
                        user={selectedRow}
                        type={'archiveLead'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        setForceUpdate={setForceUpdate}
                    />
                )}
                {openRestoreArchived && (
                    <OpenRestoreArchived
                        open={openRestoreArchived}
                        headerButtons
                        onClose={() => onCloseRestoreArchived()}
                        user={selectedRow}
                        type={'RestoreArchived'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                    />
                )}
                {openAddTreatment && (
                    <TreatmentEditPopover
                        handleReloadAPI={handleCloseTreatment}
                        open={openAddTreatment}
                        anchorEl={anchorEditTreatment}
                        handleClickAwayLister={handleCloseAddTreatment}
                        leadId={tableRowLead?.lead_id}
                        isAddTreatment
                    />
                )}
                {openTreatmentEditPopup && (
                    <TreatmentEditPopover
                        handleReloadAPI={handleReloadAPI}
                        treatmentData={selectedRow?.treatmentData}
                        treatment={selectedRow?.treatment_name || ''}
                        leadTreatmentSpecification={selectedRow?.leadTreatmentSpecification || null}
                        open={openTreatmentEditPopup}
                        anchorEl={anchorEditTreatment}
                        handleClickAwayLister={handleClickAwayLister}
                        treatmentId={selectedRow?.treatment_id}
                        treatmentPrice={selectedRow?.price}
                        treatmentCategory={selectedRow?.treatmentCategory}
                        leadId={selectedRow?.lead_id}
                    />
                )}
                {openPracticePopup && (
                    <ChangePracticePopover
                        handleReloadAPI={handleReloadAPI}
                        treatmentData={selectedRow?.treatmentData}
                        treatment={selectedRow?.treatment_name || ''}
                        leadTreatmentSpecification={selectedRow?.leadTreatmentSpecification || null}
                        open={openPracticePopup}
                        anchorEl={anchorPractice}
                        handleClickAwayLister={handleClickAwayLister}
                        treatmentId={selectedRow?.treatment_id}
                        treatmentPrice={selectedRow?.price}
                        treatmentCategory={selectedRow?.treatmentCategory}
                        currentRow={selectedRow}
                        practiceId={selectedRow?.practiceId}
                    />
                )}
                {openDepositPaymentPopup && (
                    <DepositPaymentPopover
                        rowData={selectedRow}
                        open={openDepositPaymentPopup}
                        anchorEl={anchorDepositPayment}
                        handleClickAwayLister={handleDepositPaymentOnclose}
                    />
                )}
                {openAssignTask && (
                    <ClickAwayListener onClickAway={onClickAwayEvent}>
                        <Popper open={openAssignTask} anchorEl={anchorElAssign} transition placement='bottom' sx={zIndexStyle}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={borderRadiosStyle}>
                                        <AssignTaskPopup
                                            open={openAssignTask}
                                            onClose={handleCloseAssignPopup}
                                            user={selectedRow}
                                            leadId={selectedRowId}
                                            type={'leadAssign'}
                                            assignees={tableData?.find((ele) => ele.id === selectedRowId)?.assignees?.filter(
                                                (el) => el?.user?.first_name && !el?.user?.is_superuser)?.map((ele) => ele.id)}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
                {openClinCheckStatus && (
                    <ClickAwayListener onClickAway={() => { onCloseClinCheckStatus(); setAnchorClinCheck(null); }}>
                        <Popper open={openClinCheckStatus} anchorEl={anchorClinCheck} transition placement='bottom' sx={zIndexStyle}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper>
                                        <ClinCheckStatusPopup
                                            open={openClinCheckStatus}
                                            onClose={onCloseClickCheckPopup}
                                            handleClose={handleClose}
                                            leadDetail={selectedRow}
                                            leadId={selectedRowId}
                                            type={'leadAssign'}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
                {openTreatmentPlan && (
                    <TreatmentPlanDatePicker
                        open={openTreatmentPlan}
                        onClose={() => onCloseTreatmentPlanDatePicker()}
                        user={selectedRow}
                        leadId={selectedRowId}
                        type={'leadAssign'}
                    />
                )}
                {openAppointmentAssignTask && (
                    <ClickAwayListener onClickAway={() => appointmentClickAwayEvent()}>
                        <Popper open={openAppointmentAssignTask} anchorEl={anchorElAssign} transition placement='bottom' sx={zIndexStyle}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={borderRadiosStyle}>
                                        <AppointmentAssignTaskPopup
                                            open={openAppointmentAssignTask}
                                            onClose={handleCloseAppointmentAssignPopup}
                                            user={selectedRow}
                                            leadId={selectedRowId}
                                            type={'leadAssign'}
                                            assignees={assignees}
                                            appoinmentSelectedId={appoinmentSelectedId}
                                            selectedTreatmentData={currentTreatmentData}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
                {OpenReSchedule && (
                    <OpenEditAppointmentPopup
                        open={OpenReSchedule}
                        headerButtons
                        onClose={handleReScheduleClose}
                        inputRef={inputRef}
                        appoinmentSelectData={appoinmentSelectData}
                    />
                )}
                {leadDetailModal && (
                    <EditPersonalDetailsPopup
                        open={leadDetailModal}
                        handleClose={closeEditDetails}
                        selectedRow={selectedRow}
                        type={'editLead'}
                        inputRef={personalDetailPopupRef}
                        title='Edit Details'
                        headerButtons
                    />
                )}
                {openAppointment && <OpenAppointmentPopup
                    open={openAppointment}
                    headerButtons
                    onClose={handleAppointmentClose}
                    treatmentData={selectedRow?.treatmentData[0]}
                    inputRef={inputRef}
                    type={'leadTable'}
                />}
                {open.value && <ArchivedOrRestorePopup open={open.value} onClose={open.onFalse} handleClose={handleClose} />}
                {openBulkReminder.value && (
                    isNoTaskLeadsTable
                        ? <SmartBulkReminderModal open={openBulkReminder.value} onClose={openBulkReminder.onFalse} onSuccess={() => handleClose('finish')} />
                        : <BulkReminderPopup open={openBulkReminder.value} onClose={openBulkReminder.onFalse} />
                )}
                <CustomCompleteTreatmentDialog handleClose={() => setConfirmation(false)} handleYes={() => completeTreatmentAPI()} isLoader={isLoader} open={confirmation} row={rowLead.current} practiceId={practiceId} />
                {startConfirmation && <StartTreatmentPopup
                    isOpen={startConfirmation}
                    handleCloseStartTreatment={handleCloseStartTreatment}
                    isPaymentMandatory={isPaymentMandatory}
                    depositStatus={depositStatus}
                    handleDepositPendingChange={handleDepositPendingChange}
                    startTreatmentAPI={startTreatmentAPI}
                />}
                <Dialog open={toggleDuplicatePopup} onClose={() => closeDuplicatePopup()}>
                    <DialogTitle sx={dialogTitleStyle}>
                        Are you sure you want to mark as duplicate?
                    </DialogTitle>
                    <DialogActions sx={dialogActionStyle}>
                        <Button sx={cancelBtnStyle} onClick={() => closeDuplicatePopup()}>
                            Cancel
                        </Button>
                        <Button type='submit' sx={yesBtnStyle} onClick={() => handleMarkAsDuplicateAPI()}>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={toggleUnMarkAsDuplicate} onClose={() => closeUnMarkAsDuplicate()}>
                    <DialogTitle sx={dialogTitleStyle}>
                        Are you sure you want to un mark as duplicate?
                    </DialogTitle>
                    <DialogActions sx={dialogActionStyle}>
                        <Button sx={cancelBtnStyle} onClick={() => closeUnMarkAsDuplicate()}>
                            Cancel
                        </Button>
                        <Button type='submit' sx={yesBtnStyle} onClick={() => handleUnMarkAsDuplicateAPI()}>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={toggleMarkAsSpam} onClose={() => closeMarkAsSpamDialog()}>
                    <DialogTitle sx={dialogTitleStyle}>
                        Mark {rowLead.current ? `${rowLead.current.first_name || ''} ${rowLead.current.last_name || ''}`.trim() : 'this lead'} as spam? This lead will be removed from all counts and reports.
                    </DialogTitle>
                    <DialogActions sx={dialogActionStyle}>
                        <Button sx={cancelBtnStyle} onClick={() => closeMarkAsSpamDialog()}>
                            Cancel
                        </Button>
                        <Button type='submit' sx={{ ...yesBtnStyle, bgcolor: 'error.main', '&:hover': { bgcolor: 'error.dark' } }} onClick={() => handleMarkAsSpamAPI()}>
                            Mark as Spam
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* P0 — Persistent skip-groups dialog.
                    Shown when bulk Complete skipped ≥1 non-BULK_COMPLETABLE items.
                    Groups are: needs_send (email/WA/consent), needs_data (text/date/
                    choice), needs_next_action (Book/FTA/status-change), needs_artifact
                    (file/reminder/appointment).  Not auto-dismissed — requires "Got it". */}
                <Dialog
                    open={Boolean(skipGroups)}
                    maxWidth="sm"
                    fullWidth
                    disableEscapeKeyDown
                    PaperProps={{ sx: { borderRadius: 2 } }}
                >
                    <DialogTitle sx={{ fontSize: '1rem', pb: 1 }}>
                        Some items need manual action
                    </DialogTitle>
                    <DialogContent>
                        {skipGroups && [
                            {
                                key: 'needs_next_action',
                                heading: '"Next action" items — not completed',
                                body: "These items control the lead's status (Book, Attended, FTA, etc.). Bulk complete can't choose a status on your behalf — open each lead and use the checklist to select the correct next step:",
                            },
                            {
                                key: 'needs_send',
                                heading: 'Send-required items — not completed',
                                body: 'These items send an email, WhatsApp, or other message as part of completing. Bulk complete can\'t send messages on your behalf — open each lead to send and complete:',
                            },
                            {
                                key: 'needs_data',
                                heading: 'Input-required items — not completed',
                                body: 'These items need you to fill in text, a date, a choice, or other data. Bulk complete can\'t fill this in for you — open each lead to enter the details:',
                            },
                            {
                                key: 'needs_artifact',
                                heading: 'Attachment or appointment items — not completed',
                                body: 'These items require an uploaded document, a scheduled reminder, or a booking. Bulk complete can\'t create these on your behalf — open each lead to complete:',
                            },
                        ]
                            .filter(({ key }) => skipGroups[key] && skipGroups[key].length > 0)
                            .map(({ key, heading, body }, sectionIdx) => (
                                <Stack key={key} sx={{ mb: sectionIdx < 3 ? 2 : 0 }}>
                                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                                        {heading}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                        {body}
                                    </Typography>
                                    <Stack component="ul" spacing={0.5} sx={{ pl: 2.5, m: 0 }}>
                                        {skipGroups[key].map((id) => {
                                            // Best-effort name lookup from the current page rows.
                                            // Falls back to "Lead #<id>" if the row has scrolled off.
                                            const row = tableData.find(
                                                (r) => String(r.lead_id) === String(id) || String(r.id) === String(id)
                                            );
                                            const name = row
                                                ? `${row.first_name || ''} ${row.last_name || ''}`.trim() || `Lead #${id}`
                                                : `Lead #${id}`;
                                            return (
                                                <Typography key={id} component="li" variant="body2" fontWeight={500}>
                                                    {name}
                                                </Typography>
                                            );
                                        })}
                                    </Stack>
                                </Stack>
                            ))}
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button
                            variant="contained"
                            onClick={() => setSkipGroups(null)}
                            sx={{ borderRadius: 1.5, textTransform: 'none', minWidth: 100 }}
                        >
                            Got it
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* Floating bulk action bar — portal-rendered at document.body level */}
                {isReportData && (
                    <FloatingBulkActionBar
                        practiceId={practiceId}
                        onClearSelection={() => dispatch(selectLeads({ leadId: [], type: '', loading: false }))}
                        onRefresh={refreshTableWithCurrentFilters}
                        onBulkComplete={handleBulkComplete}
                        onOpenBulkReminder={openBulkReminder.onTrue}
                        onItemsSkipped={handleItemsSkipped}
                    />
                )}
            </Box>
        </>
    );
};

function applySortFilter({ tableData }) {
    const stabilizedThis = tableData.map((el, index) => [el, index]);
    tableData = stabilizedThis.map((el) => el[0]);

    return tableData;
}

export default NewLead;

NewLead.propTypes = {
    leadData: PropTypes.array,
    updateLeadPage: PropTypes.func,
    pageCount: PropTypes.number,
    type: PropTypes.string,
    setUpdateList: PropTypes.func,
    tableTitle: PropTypes.string,
    counter: PropTypes.array,
    reloadCounter: PropTypes.func,
    reloadTaskCounter: PropTypes.func,
    onClose: PropTypes.func,
    rowStatus: PropTypes.string,
    clinCheck: PropTypes.string,
    defaultHideColumn: PropTypes.object,
    columnVisibilityModel: PropTypes.object,
    handleColumnVisibilityChange: PropTypes.func,
    handleColumnOrderChange: PropTypes.func,
    shouldRunEffect: PropTypes.object,
    dashBoardDateProps: PropTypes.object,
    isNoTaskLeadsTable: PropTypes.bool,
    selectedTab: PropTypes.string,
    setColumnVisibilityModel: PropTypes.func,
    pinProps: PropTypes.object,
    displayForCategorySummary: PropTypes.bool.isRequired,
    leadCategoryType: PropTypes.string.isRequired,
    forceReload: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    hideCounterTabs: PropTypes.bool,
    archiveReasonData: PropTypes.array,
    showPracticeColumn: PropTypes.bool,
    onDateRangeReady: PropTypes.func,
    widgetToggle: PropTypes.bool,
    isCombinedName: PropTypes.bool,
    handleToggleCombineName: PropTypes.func,
    setIsCombinedName: PropTypes.func,
    initialBookedWidgetFilter: PropTypes.string,
    isEnforcedByPractice: PropTypes.bool,
    setIsEnforcedByPractice: PropTypes.func,
    // null = built-in board scope, Number = PracticeCustomTableTab id, undefined = legacy (standalone NewLead).
    controlledCustomTabId: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
    // Bug 2c: URL-driven checklist strip state. null = no URL override (use Redux).
    checklistStateFromUrl: PropTypes.string,
    // Bug 2c: callback from ConsultantAttend to write checklistState to URL on strip change.
    onChecklistStateChange: PropTypes.func,
};
